{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2018 - 2020                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.Grids;

interface

{$HINTS OFF}

uses
  Classes, JS, WEBLib.Controls, WEBLib.Graphics, Web, DB;

type
{
  TJSTable = class external name 'Table' (TJSNode)
  private
    FRows : TJSElement; external name 'rows';

  public

  end;
}
  TInitMethod = (imRandom, imLinear);

  TGridRect = record
    Left, Top, Right, Bottom: Longint;
  end;

  TGridCoord = record
    X: Longint;
    Y: Longint;
  end;

  TGridOption = (goFixedVertLine, goFixedHorzLine, goVertLine, goHorzLine,
    goRangeSelect, goDrawFocusSelected, goRowSizing, goColSizing, goRowMoving,
    goColMoving, goEditing, goTabs, goRowSelect, goAlwaysShowEditor,
    goThumbTracking, goFixedColClick, goFixedRowClick, goFixedHotTrack);

  TFillMethod = (fmRandom);

  TGridOptions = set of TGridOption;

  TGridGetCellDataEvent = procedure(Sender: TObject; ACol,ARow: integer; AField: TField; var AValue: string) of object;

  TGridGetCellClassEvent = procedure(Sender: TObject; ACol,ARow: integer; AField: TField; AValue: string; var AClassName: string) of object;

  TGridGetCellChildrenEvent = procedure(Sender: TObject; ACol,ARow: integer; AField: TField; AValue: string; AElement: TJSHTMLElement) of object;

  TGridRequestEvent = procedure(Sender: TObject; ARequest: TJSXMLHttpRequest) of object;

  TGetEditEvent = procedure (Sender: TObject; ACol, ARow: Longint; var Value: string) of object;
  TSetEditEvent = procedure (Sender: TObject; ACol, ARow: Longint; const Value: string) of object;

  TCustomGrid = class(TCustomControl)
  private
    FRowCount: integer;
    FColCount: integer;
  protected
    procedure SetColCount(const Value: integer); virtual;
    procedure SetRowCount(const Value: integer); virtual;
    procedure GridChanged; virtual;
    procedure RowCountChanged(delta: integer); virtual;
    procedure ColCountChanged(delta: integer); virtual;
    property RowCount: integer read FRowCount write SetRowCount;
    property ColCount: integer read FColCount write SetColCount;
  public
    property Visible;
  end;

  // for VCL design-time compatibility
  TGridDrawingStyle = (gdsClassic, gdsThemed, gdsGradient);

  TCellEvent = procedure(Sender: TObject; ACol, ARow: integer) of object;
  TCellCheckEvent = procedure(Sender: TObject; ACol, ARow: integer; Checked: boolean) of object;

  TSelectCellEvent = procedure(Sender: TObject; ACol, ARow: integer; var CanSelect: boolean) of object;

  TCustomStringGrid = class(TCustomGrid)
  private
    FReq: TJSXMLHttpRequest;
    FDataNode: string;
    FOrigVal: string;
    FGrid: TJSElement;
    FFixedColor: TColor;
    FFixedColRow: TJSElement;
    FFixedRow: TJSElement;
    FFixedCol: TJSElement;
    FNormalCells: TJSElement;
    FDefaultRowHeight: integer;
    FDefaultColWidth: integer;
    FColWidths: TList;
    FRowHeights: TList;
    FSelectedCell: TJSElement;
    FEdit: TJSHTMLElement;
    FFixedCols: integer;
    FFixedRows: integer;
    FEditMode: boolean;
    FOnSelectCell: TSelectCellEvent;
    FOnTopLeftChanged: TNotifyEvent;
    FOptions: TGridOptions;
    FDelimiter: char;
    FLoadFixed: boolean;
    FSelection: TGridRect;
    FStartCell: TGridCoord;
    FOnHttpRequestError: TNotifyEvent;
    FOnHttpRequestSuccess: TNotifyEvent;
    FOnGetCellClass: TGridGetCellClassEvent;
    FOnGetCellData: TGridGetCellDataEvent;
    FOnGetCellChildren: TGridGetCellChildrenEvent;
    FScrollBars: TScrollStyle;
    FSelMouseDown: boolean;
    FStyleElements: TStyleElements;
    FDefaultDrawing: boolean;
    FDragCursor: TCursor;
    FDragKind: TDragKind;
    FDragMode: TDragMode;
    FGradientStartColor: TColor;
    FGradientEndColor: TColor;
    FEditCol: integer;
    FEditRow: integer;
    FCtl3D: boolean;
    FParentCtl3D: boolean;
    FOnGetEditText: TGetEditEvent;
    FOnSetEditText: TSetEditEvent;
    FOnHttpRequest: TGridRequestEvent;
    FOnCheckClick: TCellCheckEvent;
    FOnFixedCellClick: TCellEvent;
    FOnValidateEdit: TGetEditEvent;
    FHandleEditBlurPtr: pointer;
    FHandleEditKeypressPtr: pointer;
    FDrawingStyle: TGridDrawingStyle;
    function GetCells(ACol, ARow: integer): string;
    procedure SetCells(ACol, ARow: integer; const Value: string);
    procedure SetFixedCols(const Value: integer);
    procedure SetFixedRows(const Value: integer);
    function GetColWidths(ACol: integer): integer;
    function GetRowHeights(ARow: integer): integer;
    procedure SetColWidths(ACol: integer; const Value: integer);
    procedure SetRowHeights(ARow: integer; const Value: integer);
    procedure SetDefaultColWidth(const Value: integer);
    procedure SetDefaultRowHeight(const Value: integer);
    function GetCol: integer;
    function GetRow: integer;
    procedure SetCol(const Value: integer);
    procedure SetRow(const Value: integer);
    function GetCellElements(ACol, ARow: integer): TJSHTMLElement;
    function GetSelection: TGridRect;
    procedure SetSelection(const Value: TGridRect);
    function GetLeftCol: integer;
    function GetTopRow: integer;
    procedure SetLeftCol(const Value: integer);
    procedure SetTopRow(const Value: integer);
    procedure SetFixedColor(const Value: TColor);
  protected
    procedure MouseMove(Shift: TShiftState; X,Y: Integer); override;

    function HandleClick(Event: TJSEvent): Boolean; virtual;
    function HandleFixedClick(Event: TJSEvent): Boolean; virtual;
    function HandleMouseDown(Event: TJSMouseEvent): Boolean; virtual;
    function HandleMouseMove(Event: TJSMouseEvent): Boolean; virtual;
    function HandleMouseUp(Event: TJSMouseEvent): Boolean; virtual;
    function HandleKeyDown(Event: TJSKeyboardEvent): boolean; virtual;
    function HandleTableFocus(Event: TJSEvent): Boolean; virtual;
    function HandleScroll(Event: TJSEvent): Boolean; virtual;
    function HandleEditBlur(Event: TJSEvent): Boolean; virtual;
    function HandleEditKeyPress(Event: TJSKeyboardEvent): boolean; virtual;
    function HandleCheckBoxClick(Event: TJSEvent): Boolean; virtual;
    function HandleDoMouseUp(Event: TJSMouseEvent): Boolean; override;
    function HandleDoMouseMove(Event: TJSMouseEvent): Boolean; override;
    function DoHttpLoadJson(Event: TEventListenerEvent): boolean; virtual;
    function DoHttpLoadCsv(Event: TEventListenerEvent): boolean; virtual;
    function DoHttpAbort(Event: TEventListenerEvent): boolean; virtual;
    procedure DoHttpRequest(ARequest: TJSXMLHttpRequest); virtual;
    procedure DoCheckClick(ACol, ARow: Longint; Checked: boolean); virtual;
    function GetEditText(ACol, ARow: Longint): string; virtual;
    procedure SetEditText(ACol, ARow: Longint; const AValue: string); virtual;
    procedure GetCellData(ACol,ARow: integer; AField: TField; var AValue: string); virtual;
    procedure GetCellClassName(ACol,ARow: integer; AField: TField; AValue: string; var AClassName: string); virtual;
    procedure GetCellChildren(ACol,ARow: integer; AField: TField; AValue: string; AElement: TJSHTMLElement); virtual;
    procedure BindCellChildren(ACol,ARow: integer; AElement: TJSHTMLElement); virtual;
    procedure DoBoundsChange; override;
    function GetGridCSS: string; virtual;
    procedure RenderGrid;
    procedure RenderGridSize;
    procedure RenderGridScript;
    procedure UpdateGridSize;
    procedure BindEvents; override;
    procedure Resize; override;
    procedure GridChanged; override;
    function CreateElement: TJSElement; override;
    procedure UpdateElement; override;
    procedure UpdateElementVisual; override;
    function FixedColWidth: integer;
    function FixedRowHeight: integer;
    function NormalColWidth: integer;
    function NormalRowHeight: integer;
    function FocusedCell: TJSElement;
    function CanSelect(ACol, ARow: integer): boolean; virtual;
    procedure SelectCell(ACol, ARow: integer); virtual;
    procedure UpdateCell(ACol, ARow: integer; var AValue: string); virtual;
    procedure ValidateCell(ACol, ARow: integer; var AValue: string); virtual;
    procedure TopLeftChanged; virtual;
    procedure RowCountChanged(delta: integer); override;
    procedure ColCountChanged(delta: integer); override;
    procedure ClearMethodPointers; override;
    procedure GetMethodPointers; override;
    procedure StartEdit(ch: string); virtual;
    function StopEdit: string; virtual;
    procedure ChangeRow; virtual;
    property ColCount;
    property RowCount;
    property OnHttpRequestError: TNotifyEvent read FOnHttpRequestError write FOnHttpRequestError;
    property OnHttpRequestSuccess: TNotifyEvent read FOnHttpRequestSuccess write FOnHttpRequestSuccess;
    property OnHttpRequest: TGridRequestEvent read FOnHttpRequest write FOnHttpRequest;
    procedure EnableColResize;
  public
    constructor Create(AOwner: TComponent); override; overload;
    destructor Destroy; override;
    procedure CreateInitialize; override;
    procedure SetFocus; override;
    procedure ShowEdit; virtual;
    procedure HideEdit; virtual;
    procedure Clear;
    procedure InitSample(AInitMethod: TInitMethod);
    property Ctl3D: boolean read FCtl3D write FCtl3D;
    property ParentCtl3D: boolean read FParentCtl3D write FParentCtl3D;
    property Col: integer read GetCol write SetCol;
    property Row: integer read GetRow write SetRow;
    property Selection: TGridRect read GetSelection write SetSelection;
    property EditMode: boolean read FEditMode;
    procedure MouseToCell(X,Y: integer; var C, R: integer);
    procedure LoadFromJSON(const AURL: string; ADataNode: string = '');
    procedure LoadFromCSV(const AURL: string; Delimiter: char = ';'; LoadFixed: boolean = false);
    property CellElements[ACol,ARow: integer]: TJSHTMLElement read GetCellElements;
    property Cells[ACol,ARow: integer]: string read GetCells write SetCells;
    property ColWidths[ACol: integer]: integer read GetColWidths write SetColWidths;
    property RowHeights[ARow: integer]: integer read GetRowHeights write SetRowHeights;
    property FixedColRow: TJSElement read FFixedColRow;
    property FixedCol: TJSElement read FFixedCol;
    property FixedRow: TJSElement read FFixedRow;
    property TopRow: integer read GetTopRow write SetTopRow;
    property LeftCol: integer read GetLeftCol write SetLeftCol;
    // for design-time VCL class compatibility
    property DefaultDrawing: boolean read FDefaultDrawing write FDefaultDrawing;
    property DragCursor: TCursor read FDragCursor write FDragCursor;
    property DragKind: TDragKind read FDragKind write FDragKind;
    property DragMode: TDragMode read FDragMode write FDragMode;
    property DrawingStyle: TGridDrawingStyle read FDrawingStyle write FDrawingStyle;
    property GradientEndColor: TColor read FGradientEndColor write FGradientEndColor;
    property GradientStartColor: TColor read FGradientStartColor write FGradientStartColor;
  published
    property Align;
    property AlignWithMargins;
    property Anchors;
    property BorderStyle;
    property DefaultColWidth: integer read FDefaultColWidth write SetDefaultColWidth default 64;
    property DefaultRowHeight: integer read FDefaultRowHeight write SetDefaultRowHeight default 24;
    property ElementID;
    property ElementClassName;
    property ElementFont;
    property ElementPosition;
    property FixedRows: integer read FFixedRows write SetFixedRows default 1;
    property FixedCols: integer read FFixedCols write SetFixedCols default 1;
    property FixedColor: TColor read FFixedColor write SetFixedColor default clBtnFace;
    property Height;
    property HeightPercent;
    property HeightStyle;
    property Margins;
    property Options: TGridOptions read FOptions write FOptions;
    property ParentFont;
    property Scrollbars: TScrollStyle read FScrollBars write FScrollBars default ssBoth;
    property StyleElements: TStyleElements read FStyleElements write FStyleElements;
    property TabOrder;

    property Visible;
    property Width;
    property WidthPercent;
    property WidthStyle;

    property OnClick;
    property OnDblClick;
    property OnEnter;
    property OnExit;
    property OnGetCellData: TGridGetCellDataEvent read FOnGetCellData write FOnGetCellData;
    property OnGetCellChildren: TGridGetCellChildrenEvent read FOnGetCellChildren write FOnGetCellChildren;
    property OnGetCellClass: TGridGetCellClassEvent read FOnGetCellClass write FOnGetCellClass;
    property OnCheckClick: TCellCheckEvent read FOnCheckClick write FOnCheckClick;
    property OnFixedCellClick: TCellEvent read FOnFixedCellClick write FOnFixedCellClick;
    property OnGetEditText: TGetEditEvent read FOnGetEditText write FOnGetEditText;
    property OnSetEditText: TSetEditEvent read FOnSetEditText write FOnSetEditText;
    property OnSelectCell: TSelectCellEvent read FOnSelectCell write FOnSelectCell;
    property OnTopLeftChanged: TNotifyEvent read FOnTopLeftChanged write FOnTopLeftChanged;
    property OnValidateEdit: TGetEditEvent read FOnValidateEdit write FOnValidateEdit;
  end;

  TStringGrid = class(TCustomStringGrid)
  published
    property ColCount;
    property RowCount;
    property OnHttpRequestError;
    property OnHttpRequestSuccess;
  end;

  TWebStringGrid = class(TStringGrid);

  TCustomTableControl = class;

  TTableControlOptions = class(TPersistent)
  private
    FOwner: TCustomTableControl;
    FScrollVertical: boolean;
    FResizeColumns: boolean;
    procedure SetResizeColumns(const Value: boolean);
  public
    constructor Create(AOwner: TCustomTableControl);
    procedure Assign(Source: TPersistent); override;
  published
    property ScrollVertical: boolean read FScrollVertical write FScrollVertical default false;
    property ResizeColumns: boolean read FResizeColumns write SetResizeColumns default false;
  end;

  TCustomTableControl = class(TCustomGrid)
  private
    FReq: TJSXMLHttpRequest;
    FDataNode: string;
    FTable: TJSElement;
    FBody: TJSElement;
    FRowHeader: boolean;
    FColHeader: boolean;
    FDelimiter: char;
    FLoadFixed: boolean;
    FElementHeaderClassName: TElementClassName;
    FElementTableClassName: TElementClassName;
    FOnHttpRequestError: TNotifyEvent;
    FOnHttpRequestSuccess: TNotifyEvent;
    FOnDblClickCell: TCellEvent;
    FOnClickCell: TCellEvent;
    FOptions: TTableControlOptions;
    FOnGetCellClass: TGridGetCellClassEvent;
    FOnGetCellData: TGridGetCellDataEvent;
    FOnGetCellChildren: TGridGetCellChildrenEvent;
    FOnHttpRequest: TGridRequestEvent;
    FOnCheckClick: TCellCheckEvent;
    function GetCells(col, row: integer): string;
    procedure SetCells(col, row: integer; const Value: string);
    function GetRowClassName(row: integer): TElementClassName;
    procedure SetRowClassName(row: integer; const Value: TElementClassName);
    function GetCellElement(col, row: integer): TJSHTMLElement;
    procedure SetOptions(const Value: TTableControlOptions);
    procedure SetElementHeaderClassName(const Value: TElementClassName);
    procedure SetElementTableClassName(const Value: TElementClassName);
  protected
    function HandleDoClick(Event: TJSMouseEvent): Boolean; override;
    function HandleDoDblClick(Event: TJSMouseEvent): Boolean; override;
    function HandleCheckBoxClick(Event: TJSEvent): Boolean; virtual;
    function HandleDoMouseUp(Event: TJSMouseEvent): Boolean; override;
    function HandleDoMouseMove(Event: TJSMouseEvent): Boolean; override;
    procedure DoCheckClick(ACol, ARow: Longint; Checked: boolean); virtual;
    function DoHttpLoadJson(Event: TEventListenerEvent): boolean; virtual;
    function DoHttpLoadCsv(Event: TEventListenerEvent): boolean; virtual;
    function DoHttpAbort(Event: TEventListenerEvent): boolean; virtual;
    procedure DoHttpRequest(ARequest: TJSXMLHttpRequest); virtual;
    procedure GetCellData(ACol,ARow: integer; AField: TField; var AValue: string); virtual;
    procedure GetCellClassName(ACol,ARow: integer; AField: TField; AValue: string; var AClassName: string); virtual;
    procedure GetCellChildren(ACol,ARow: integer; AField: TField; AValue: string; AElement: TJSHTMLElement); virtual;
    procedure BindCellChildren(ACol,ARow: integer; AElement: TJSHTMLElement); virtual;
    procedure RenderGrid;
    procedure RenderGridScript;
    procedure BindEvents; override;
    function CreateElement: TJSElement; override;
    procedure UpdateElement; override;
    procedure SetRowCount(const Value: integer); override;
    procedure RowCountChanged(delta: integer); override;
    procedure ColCountChanged(delta: integer); override;
    property OnHttpRequestError: TNotifyEvent read FOnHttpRequestError write FOnHttpRequestError;
    property OnHttpRequestSuccess: TNotifyEvent read FOnHttpRequestSuccess write FOnHttpRequestSuccess;
    property OnHttpRequest: TGridRequestEvent read FOnHttpRequest write FOnHttpRequest;
    property RowCount;
    property ColCount;
    procedure EnableColResize;
  public
    constructor Create(AOwner: TComponent); override; overload;
    procedure CreateInitialize; override;
    destructor Destroy; override;
    procedure InitSample(AInitMethod: TInitMethod);
    procedure LoadFromJSON(const AURL: string; ADataNode: string = '');
    procedure LoadFromCSV(const AURL: string; Delimiter: char = ';'; LoadFixed: boolean = false);
    procedure AddCheckBox(ACol, ARow: integer; Checked: boolean);
    procedure Clear;
    property Cells[col,row: integer]: string read GetCells write SetCells;
    property CellElements[col,row: integer]: TJSHTMLElement read GetCellElement;
    property RowClassName[row: integer]: TElementClassName read GetRowClassName write SetRowClassName;
  published
    property Align;
    property AlignWithMargins;
    property Anchors;
    property BorderColor;
    property BorderStyle;
    property Color;
    property ElementClassName;
    property ElementFont;
    property ElementID;
    property ElementPosition;
    property ElementHeaderClassName: TElementClassName read FElementHeaderClassName write SetElementHeaderClassName;
    property ElementTableClassName: TElementClassName read FElementTableClassName write SetElementTableClassName;
    property Height;
    property HeightPercent;
    property HeightStyle;
    property Margins;
    property RowHeader: boolean read FRowHeader write FRowHeader default true;
    property ColHeader: boolean read FColHeader write FColHeader default true;
    property Options: TTableControlOptions read FOptions write SetOptions;
    property Visible;
    property Width;
    property WidthPercent;
    property WidthStyle;
    property OnCheckClick: TCellCheckEvent read FOnCheckClick write FOnCheckClick;
    property OnClick;
    property OnClickCell: TCellEvent read FOnClickCell write FOnClickCell;
    property OnDblClickCell: TCellEvent read FOnDblClickCell write FOnDblClickCell;
    property OnDblClick;
    property OnGetCellData: TGridGetCellDataEvent read FOnGetCellData write FOnGetCellData;
    property OnGetCellChildren: TGridGetCellChildrenEvent read FOnGetCellChildren write FOnGetCellChildren;
    property OnGetCellClass: TGridGetCellClassEvent read FOnGetCellClass write FOnGetCellClass;
  end;

  TTableControl = class(TCustomTableControl)
  published
    property RowCount;
    property ColCount;
    property OnHttpRequestError;
    property OnHttpRequestSuccess;
  end;

  TWebTableControl = class(TTableControl);

  TResponsiveGridItem = class(TCollectionItem)
  private
    FHTML: string;
    FElementHandle: TJSHTMLElement;
    FTag: integer;
    FItemObject: TObject;
    procedure SetHTML(const Value: string);
  public
    property ElementHandle: TJSHTMLElement read FElementHandle;
    property ItemObject: TObject read FItemObject write FItemObject;
  published
    property HTML: string read FHTML write SetHTML;
    property Tag: integer read FTag write FTag default 0;
  end;

  TResponsiveGridItemEvent = procedure(Sender: TObject; Index: integer) of object;

  TResponsiveGridItemFieldValueEvent = procedure(Sender: TObject; Index: integer; AFieldName: string; var AValue: string) of object;

  TResponsiveGridItems = class(TOwnedCollection)
  private
    FOnItemDelete: TResponsiveGridItemEvent;
    FOnItemUpdate: TResponsiveGridItemEvent;
    FOnItemInsert: TResponsiveGridItemEvent;
    FOnItemAdd: TResponsiveGridItemEvent;
    FOnItemClear: TNotifyEvent;
    function GetItem(Index: integer): TResponsiveGridItem;
    procedure SetItem(Index: integer; const Value: TResponsiveGridItem);
  protected
    procedure DoItemClear; virtual;
    procedure DoItemAdd(Index: integer); virtual;
    procedure DoItemDelete(Index: integer); virtual;
    procedure DoItemInsert(Index: integer); virtual;
    procedure DoItemUpdate(Index: integer); virtual;
    property OnItemAdd: TResponsiveGridItemEvent read FOnItemAdd write FOnItemAdd;
    property OnItemUpdate: TResponsiveGridItemEvent read FOnItemUpdate write FOnItemUpdate;
    property OnItemDelete: TResponsiveGridItemEvent read FOnItemDelete write FOnItemDelete;
    property OnItemInsert: TResponsiveGridItemEvent read FOnItemInsert write FOnItemInsert;
    property OnItemClear: TNotifyEvent read FOnItemClear write FOnItemClear;
    procedure Update(Item: TCollectionItem); override;
  public
    constructor Create(AOwner: TComponent);
    procedure Clear;
    procedure Delete(Index: integer);
    function Add: TResponsiveGridItem;
    function Insert(Index: integer): TResponsiveGridItem;
    property Items[Index: integer]: TResponsiveGridItem read GetItem write SetItem; default;
  end;

  TResponsiveGridOptions = class(TPersistent)
  private
    FItemWidthMin: integer;
    FItemHeight: integer;
    FItemGap: integer;
    FScrollVertical: boolean;
    FItemClassName: string;
    FItemColor: TColor;
    FItemBorderColor: TColor;
    FItemHoverColor: TColor;
    FItemHoverBorderColor: TColor;
    FOnChange: TNotifyEvent;
    FItemPadding: integer;
    FItemTemplate: string;
    FItemSelectedBorderColor: TColor;
    FItemSelectedTextColor: TColor;
    FItemSelectedColor: TColor;
    procedure SetItemBorderColor(const Value: TColor);
    procedure SetItemColor(const Value: TColor);
    procedure SetItemGap(const Value: integer);
    procedure SetItemHeight(const Value: integer);
    procedure SetItemHoverBorderColor(const Value: TColor);
    procedure SetItemHoverColor(const Value: TColor);
    procedure SetItemWidthMin(const Value: integer);
    procedure SetScrollVertical(const Value: boolean);
    procedure SetItemPadding(const Value: integer);
    procedure SetItemTemplate(const Value: string);
    procedure SetItemSelectedBorderColor(const Value: TColor);
    procedure SetItemSelectedColor(const Value: TColor);
    procedure SetItemSelectedTextColor(const Value: TColor);
  protected
    procedure Changed;
  public
    constructor Create;
    procedure Assign(Source: TPersistent); override;
  published
    property ItemClassName: string read FItemClassName write FItemClassName;
    property ItemColor: TColor read FItemColor write SetItemColor default clNone;
    property ItemBorderColor: TColor read FItemBorderColor write SetItemBorderColor default clNone;
    property ItemGap: integer read FItemGap write SetItemGap default 10;
    property ItemHeight: integer read FItemHeight write SetItemHeight default 100;
    property ItemHoverColor: TColor read FItemHoverColor write SetItemHoverColor default clNone;
    property ItemHoverBorderColor: TColor read FItemHoverBorderColor write SetItemHoverBorderColor default clNone;
    property ItemSelectedColor: TColor read FItemSelectedColor write SetItemSelectedColor default clNone;
    property ItemSelectedBorderColor: TColor read FItemSelectedBorderColor write SetItemSelectedBorderColor default clNone;
    property ItemSelectedTextColor: TColor read FItemSelectedTextColor write SetItemSelectedTextColor default clNone;
    property ItemPadding: integer read FItemPadding write SetItemPadding default 0;
    property ItemTemplate: string read FItemTemplate write SetItemTemplate;
    property ItemWidthMin: integer read FItemWidthMin write SetItemWidthMin default 100;
    property ScrollVertical: boolean read FScrollVertical write SetScrollVertical default True;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
  end;

  TResponsiveGrid = class(TCustomControl)
  private
    FReq: TJSXMLHttpRequest;
    FDataNode: string;
    FOptions: TResponsiveGridOptions;
    FItems: TResponsiveGridItems;
    FOnItemDblClick: TResponsiveGridItemEvent;
    FOnItemClick: TResponsiveGridItemEvent;
    FOnHttpRequestError: TNotifyEvent;
    FOnHttpRequestSuccess: TNotifyEvent;
    FOnItemCreated: TResponsiveGridItemEvent;
    FOnItemGetFieldValue: TResponsiveGridItemFieldValueEvent;
    FItemIndex: integer;
    FDelimiter: char;
    FOnHttpRequest: TGridRequestEvent;
    FListElement: TJSHTMLElement;
    procedure SetOptions(const Value: TResponsiveGridOptions);
    procedure SetItems(const Value: TResponsiveGridItems);
    procedure SetItemIndex(const Value: integer);
  protected
    function DoHttpLoadJson(Event: TEventListenerEvent): boolean; virtual;
    function DoHttpLoadCsv(Event: TEventListenerEvent): boolean; virtual;
    function DoHttpAbort(Event: TEventListenerEvent): boolean; virtual;
    procedure DoHttpRequest(ARequest: TJSXMLHttpRequest); virtual;
    procedure DoItemCreated(Index: integer); virtual;
    procedure DoItemGetFieldValue(Index: integer; AFieldName: string; var AValue: string); virtual;

    procedure HandleDoItemClick(Index: integer); virtual;
    procedure HandleDoItemDblClick(Index: integer); virtual;
    function TargetIsParent(tgt,el: TJSElement): boolean; virtual;
    function HandleDoMouseEnter(Event: TJSMouseEvent): Boolean; override;
    function HandleDoClick(Event: TJSMouseEvent): Boolean; override;
    function HandleDoDblClick(Event: TJSMouseEvent): Boolean; override;
    procedure HandleItemAdd(Sender:  TObject; Index: integer);
    procedure HandleItemUpdate(Sender:  TObject; Index: integer);
    procedure HandleItemDelete(Sender:  TObject; Index: integer);
    procedure HandleItemInsert(Sender:  TObject; Index: integer);
    procedure HandleItemClear(Sender: TObject);
    procedure OptionsChanged(Sender: TObject); virtual;
    procedure FontChanged; override;
    function CreateElement: TJSElement; override;
    procedure CreateControl; override;
    procedure BindElement; override;
    procedure UpdateElement; override;
    procedure RenderGrid;
    procedure Loaded; override;
  public
    constructor Create(AOwner: TComponent); override; overload;
    procedure CreateInitialize; override;
    destructor Destroy; override;
    procedure LoadFromJSON(const AURL: string; ADataNode: string = '');
    procedure LoadFromCSV(const AURL: string; Delimiter: char = ';');
    function ListElementHandle: TJSElement;
  published
    property Align;
    property AlignWithMargins;
    property Anchors;
    property ElementID;
    property ElementClassName;
    property ElementFont;
    property ElementPosition;
    property Height;
    property HeightPercent;
    property HeightStyle;

    property ItemIndex: integer read FItemIndex write SetItemIndex default 0;
    property Items: TResponsiveGridItems read FItems write SetItems;
    property Margins;
    property Options: TResponsiveGridOptions read FOptions write SetOptions;
    property ParentFont;
    property Visible;
    property Width;
    property WidthPercent;
    property WidthStyle;
    property OnClick;
    property OnDblClick;
    property OnMouseDown;
    property OnMouseUp;
    property OnMouseMove;
    property OnMouseLeave;
    property OnMouseEnter;
    property OnItemCreated: TResponsiveGridItemEvent read FOnItemCreated write FOnItemCreated;
    property OnItemGetFieldValue: TResponsiveGridItemFieldValueEvent read FOnItemGetFieldValue write FOnItemGetFieldValue;
    property OnItemClick: TResponsiveGridItemEvent read FOnItemClick write FOnItemClick;
    property OnItemDblClick: TResponsiveGridItemEvent read FOnItemDblClick write FOnItemDblClick;
    property OnHttpRequestError: TNotifyEvent read FOnHttpRequestError write FOnHttpRequestError;
    property OnHttpRequestSuccess: TNotifyEvent read FOnHttpRequestSuccess write FOnHttpRequestSuccess;
    property OnHttpRequest: TGridRequestEvent read FOnHttpRequest write FOnHttpRequest;
  end;

  TWebResponsiveGrid = class(TResponsiveGrid);

function GridRect(Left,Top,Right,Bottom: integer): TGridRect;

implementation

uses
  SysUtils, Math;

function GridRect(Left,Top,Right,Bottom: integer): TGridRect;
begin
  Result.Left := Left;
  Result.Top := Top;
  Result.Right := Right;
  Result.Bottom := Bottom;
end;

{ TCustomStringGrid }

procedure TCustomStringGrid.BindCellChildren(ACol, ARow: integer; AElement: TJSHTMLElement);
var
  el: TJSHTMLElement;
begin
  el := TJSHTMLElement(AElement.firstChild);

  if Assigned(el) and (el.tagName = 'INPUT') then
  begin
    if (lowercase(el.getAttribute('TYPE'))= 'checkbox') then
    begin
      el.addEventListener('click', @HandleCheckBoxClick);
    end;
  end;
end;

procedure TCustomStringGrid.BindEvents;
begin
  inherited;
  RenderGridScript;
end;

function TCustomStringGrid.CanSelect(ACol, ARow: integer): boolean;
begin
  Result := true;
  if Assigned(OnSelectCell) then
    OnSelectCell(Self, ACol, ARow, Result);
end;

procedure TCustomStringGrid.ChangeRow;
begin
  //
end;

procedure TCustomStringGrid.Clear;
var
  c,r: integer;
begin
  for c := 0 to ColCount - 1 do
    for r := 0 to Rowcount - 1 do
      Cells[c,r] := '';
end;

procedure TCustomStringGrid.ClearMethodPointers;
begin
  inherited;
  FHandleEditBlurPtr := nil;
  FHandleEditKeypressPtr := nil;
end;

procedure TCustomStringGrid.ColCountChanged(delta: integer);
var
  c: integer;
begin
  if IsUpdating then
    Exit;

  if delta > 0 then
  begin
    asm
      var i = 0;
      var j = 0;
      var k = 0;
      var tr = undefined;
      var td = undefined;
      var sizediv,div = undefined;

      var l = this.FNormalCells.rows.length;

      for(j = 0; j < l; j++)
      {
        tr = this.FNormalCells.rows[j];

        k = tr.cells.length;

         for(i = 0; i < delta; i++)
         {
           tr.insertCell(k);
         }
      }

      for(j = 0; j < this.FFixedRows; j++)
      {

        k = this.FFixedRow.rows[j].cells.length;

        for(i = 0; i < delta; i++)
        {
          td = this.FFixedRow.rows[j].insertCell(k);
          div = document.createElement("DIV");
          div.style = 'position:relative;height:100%;width:100%';
          td.appendChild(div);
          sizediv = document.createElement("DIV");
          sizediv.style = 'position:absolute;height:100%;width:5px;margin-right:-5px;left:100%;top:0px;cursor:w-resize;z-index:999;';
          div.appendChild(sizediv);
        }
      }
    end;

    for c := 1 to delta do
    begin
      ColWidths[ColCount - c] := DefaultColWidth;
    end;
  end;

  if delta < 0 then
  begin

    asm
      var i = 0;
      var j = 0;
      var k = 0;
      var tr = undefined;

      var l = this.FNormalCells.rows.length;

      for(j = 0; j < l; j++)
      {
        tr = this.FNormalCells.rows[j];

        k = tr.cells.length;

         for(i = 0; i < -delta; i++)
         {
           tr.deleteCell(k - i - 1);
         }
      }

      k = this.FFixedRow.rows[0].cells.length;

      for(i = 0; i < -delta; i++)
      {
        this.FFixedRow.rows[0].deleteCell(k- i - 1);
      }
    end;

    if ColCount > 0 then
      ColWidths[ColCount - 1] := ColWidths[ColCount - 1];
  end;
end;

constructor TCustomStringGrid.Create(AOwner: TComponent);
begin
  inherited;
end;

function TCustomStringGrid.CreateElement: TJSElement;
begin
  Result := document.createElement('SPAN');
  FGrid := nil;
end;

procedure TCustomStringGrid.CreateInitialize;
begin
  inherited;
  FColWidths := TList.Create;
  FRowHeights := TList.Create;

  FStartCell.X := -1;
  FStartCell.Y := -1;
  FFixedColor := clBtnFace;
  FRowCount := 5;
  FColCount := 5;
  FFixedCols := 1;
  FFixedRows := 1;
  FDefaultColWidth := 64;
  FDefaultRowHeight := 22;
  ElementFont := efProperty;
  ElementPosition := epAbsolute;
  ScrollBars := ssBoth;
  Options := [goHorzLine, goVertLine];
  if (csDesigning in ComponentState) then
  begin
    Width := 400;
    Height := 300;
  end;
end;

destructor TCustomStringGrid.Destroy;
begin
  FColWidths.Free;
  FRowHeights.Free;
  inherited;
end;

function TCustomStringGrid.DoHttpLoadCsv(Event: TEventListenerEvent): boolean;
var
  sl: TStringList;
  arow: TStringList;
  i,j: integer;
  sr,sc: integer;
  cd, cn: string;
  ce: TJSHTMLElement;
  req: TJSXMLHttpRequest;
begin
  req := TJSXMLHttpRequest(Event.target);

  if (req.status >= 200) and (req.status <= 208) then
  begin
    sl := TStringList.Create;

    sl.Text := req.responseText;

    RowCount := sl.Count + FixedRows;

    arow := TStringList.Create;

    sc := FixedCols;
    sr := FixedRows;

    if FLoadFixed then
    begin
      sr := 0;
      sc := 0;
    end;

    try
      for i := 0 to sl.Count - 1 do
        begin
          arow.StrictDelimiter := true;
          arow.Delimiter := FDelimiter;
          arow.DelimitedText := sl.Strings[i];

          if arow.Count > ColCount - FixedCols then
            ColCount := arow.Count + FixedCols;

          for j := 0 to arow.Count - 1 do
          begin
            cd := arow.Strings[j];
            GetCellData(j + sc, i + sr, nil, cd);
            Cells[j + sc, i + sr] := cd;

            ce := CellElements[j + sc, i + sr];

            GetCellChildren(j + sc, i + sr, nil, cd, ce);

            cn := '';
            GetCellClassName(j + sc, i + sr, nil, cd, cn);
            if cn <> '' then
              ce.setAttribute('class',cn);
          end;
        end;
    finally
      arow.Free;
      sl.Free;
    end;

    if Assigned(OnHttpRequestSuccess) then
      OnHttpRequestSuccess(Self);
  end;

  Result := true;
end;

{$HINTS OFF}
function TCustomStringGrid.DoHttpLoadJson(Event: TEventListenerEvent): boolean;
var
  J: TJSObject;
  JO: JSValue;
  JA: TJSArray;
  r,c: integer;
  arow: string;
  sl: TStringList;
  ce: TJSHTMLElement;
  cd, cn: string;
  req: TJSXMLHttpRequest;
begin
  req := TJSXMLHttpRequest(Event.target);

  if (req.status >= 200) and (req.status <= 208) then
  begin
    J := TJSJSON.parseObject(req.responseText);

    if FDataNode <> '' then
      JA := TJSArray(J.Properties[FDataNode])
    else
      JA := TJSArray(J);

    if Assigned(JA) then
    begin
      sl := TStringList.Create;

      RowCount := JA.length +  FixedRows;

      for r := 0 to JA.length - 1 do
      begin
        JO := JA.Elements[r];

        c := 0;
        arow := '';

        asm
          var x = undefined;
          for (x in JO) {
            arow += "|" + JO[x];
            c++;
          }
        end;

        Delete(arow, 1, 1);
        sl.StrictDelimiter := true;
        sl.Delimiter := '|';
        sl.DelimitedText := arow;
        if ColCount < sl.Count  then
          ColCount := sl.Count + FixedCols;

        for c := 0 to sl.Count - 1 do
        begin
          cd := sl.Strings[c];
          GetCellData(FixedCols + c, FixedRows + r, nil, cd);
          Cells[FixedCols + c, FixedRows + r] := cd;
          cn := '';

          ce := CellElements[FixedCols + c, FixedRows + r];

          GetCellChildren(FixedCols + c, FixedRows + r, nil, cd, ce);

          GetCellClassName(FixedCols + c, FixedRows + r, nil, cd, cn);
          if cn <> '' then
            ce.setAttribute('class',cn);
        end;
      end;

      sl.Free;
    end;

    UpdateGridSize;

    if Assigned(OnHttpRequestSuccess) then
      OnHttpRequestSuccess(Self);
  end;

  Result := true;
end;


procedure TCustomStringGrid.DoHttpRequest(ARequest: TJSXMLHttpRequest);
begin
  if Assigned(OnHttpRequest) then
    OnHttpRequest(Self, ARequest);
end;

procedure TCustomStringGrid.EnableColResize;
var
  TableName: string;
  ResizeEnabled: Boolean;
begin
  if not (csDesigning in ComponentState) then
  begin
    TableName := GetID + 'ResizeRow';

    ResizeEnabled := (goColSizing in Options);
    asm
      TMSStringGridresizableGrid(TableName, ResizeEnabled);
    end;

    TableName := GetID + 'ResizeFixedRow';
    ResizeEnabled := (goColSizing in Options);
    asm
      TMSStringGridresizableGrid(TableName, ResizeEnabled);
    end;
  end;
end;

{$HINTS ON}

procedure TCustomStringGrid.DoBoundsChange;
var
  fw,fh,nwvis,nhvis: integer;

begin
  inherited;

  if Assigned(ElementHandle) then
  begin

    UpdateGridSize;

    fw := FixedColWidth;
    fh := FixedRowHeight;

    nwvis := Width - fw;
    nhvis := Height - fh;

    if Assigned(FNormalCells) then
    begin
      TJSHTMLElement(FNormalCells.parentElement.parentElement).style.setProperty('width',inttostr(nwvis)+'px');
      TJSHTMLElement(FNormalCells.parentElement.parentElement).style.setProperty('height',inttostr(nhvis)+'px');
    end;
  end;
end;

procedure TCustomStringGrid.DoCheckClick(ACol, ARow: Longint; Checked: boolean);
begin
  if Assigned(OnCheckClick) then
    OnCheckClick(Self, ACol, ARow, Checked);
end;

function TCustomStringGrid.DoHttpAbort(Event: TEventListenerEvent): boolean;
begin
  if Assigned(OnHttpRequestError) then
    OnHttpRequestError(Self);

  Result := true;
end;

function TCustomStringGrid.FixedColWidth: integer;
var
  i: integer;
begin
  Result := 0;

  for i := 0 to FixedCols - 1 do
    Result := Result + ColWidths[i];
end;

function TCustomStringGrid.FixedRowHeight: integer;
var
  i: integer;
begin
  Result := 0;

  for i := 0 to FixedRows - 1 do
    Result := Result + RowHeights[i];
end;

function TCustomStringGrid.FocusedCell: TJSElement;
begin
  Result := FSelectedCell;
end;

procedure TCustomStringGrid.GetCellChildren(ACol, ARow: integer; AField: TField;
  AValue: string; AElement: TJSHTMLElement);
begin
  if Assigned(OnGetCellChildren) then
    OnGetCellChildren(Self, ACol, ARow, AField, AValue, AElement);
end;

procedure TCustomStringGrid.GetCellClassName(ACol, ARow: integer;
  AField: TField; AValue: string; var AClassName: string);
begin
  if Assigned(OnGetCellClass) then
    OnGetCellClass(Self, ACol, ARow, AField, AValue, AClassName);
end;

procedure TCustomStringGrid.GetCellData(ACol, ARow: integer; AField: TField;
  var AValue: string);
begin
  if Assigned(OnGetCellData) then
    OnGetCellData(Self, ACol, ARow, AField, AValue);
end;

{$HINTS OFF}
function TCustomStringGrid.GetCellElements(ACol, ARow: integer): TJSHTMLElement;
var
  rc,rr: integer;
  res: TJSHTMLElement;
begin
  if (ACol < FixedCols) and (ARow >= FixedRows) then
  begin
    rr := ARow - FixedRows;
    rc := ACol;

    asm
      res = this.FFixedCol.rows[rr].cells[rc];
    end;
  end;

  if (ARow < FixedRows) and (ACol >= FixedCols) then
  begin
    rc := ACol - FixedCols;
    rr := ARow;

    asm
      res = this.FFixedRow.rows[rr].cells[rc];
    end;
  end;

  if (ACol < FixedCols) and (ARow < FixedRows) then
  begin
    asm
      res = this.FFixedColRow.rows[rr].cells[rc];
    end;
  end;

  if (ACol >= FixedCols) and (ARow >= FixedRows) then
  begin
    rc := ACol - FixedCols;
    rr := ARow - FixedRows;
    asm
      res = this.FNormalCells.rows[rr].cells[rc];
    end;
  end;

  Result := res;
end;
{$HINTS ON}

function TCustomStringGrid.GetCells(ACol, ARow: integer): string;
var
  td: TJSHTMLElement;
begin
  td := CellElements[ACol,ARow];
  Result := td.innerHTML;
end;

function TCustomStringGrid.GetCol: integer;
var
  res: integer;
begin
  res := -1;
  if  Assigned(FSelectedCell) then
  begin
    asm
      res = this.FSelectedCell.cellIndex;
    end;
    res := res + FixedCols;
  end;

  Result := res;
end;

function TCustomStringGrid.GetColWidths(ACol: integer): integer;
begin
  if ACol < FColWidths.Count then
    Result := integer(FColWidths.Items[ACol])
  else
    Result := DefaultColWidth;
end;

function TCustomStringGrid.GetEditText(ACol, ARow: Longint): string;
begin
  Result := Cells[ACol,ARow];

  if Assigned(OnGetEditText) then
    OnGetEditText(Self, ACol, ARow, Result);
end;

function TCustomStringGrid.GetGridCSS: string;
begin
  Result := '';

  if not (goVertLine in Options) then
    Result := 'border-left: 0px; border-right: 0px;';

  if not (goHorzLine in Options) then
    Result := Result + 'border-top: 0px; border-bottom: 0px;';

  if ElementFont = efProperty then
    Result := Result + CSSFont(Font);

  Result := 'table.tstringgrid td { overflow: hidden; text-overflow: ellipsis; white-space:nowrap; border: solid 1px #cccccc; padding: 0px;' + Result + '} '+
                   'table.tstringgrid td.selected { background-color: #5B8FFF; color: #FFFFFF; } '+
                   'table.tstringgrid tr.selected { background-color: #5B8FFF; color: #FFFFFF; } ';
end;

function TCustomStringGrid.GetLeftCol: integer;
var
  i,w,l: integer;
begin
  Result := FixedCols;


  if Assigned(FNormalCells) then
  begin
    l := FNormalCells.parentElement.parentElement.scrollLeft;
    w := 0;
    for i := FixedCols to ColCount - 1 do
    begin
     if l <= w then
     begin
       Result := i;
       break;
     end;
      w := w + ColWidths[i]+1;
    end;
  end;
end;

procedure TCustomStringGrid.GetMethodPointers;
begin
  inherited;
  FHandleEditBlurPtr := @HandleEditBlur;
  FHandleEditKeypressPtr := @HandleEditKeypress;
end;

function TCustomStringGrid.GetRow: integer;
var
  res: integer;
begin
  res := -1;
  if Assigned(FSelectedCell) then
  begin
    asm
      res = this.FSelectedCell.parentElement.rowIndex;
    end;
    res := res + FixedRows;
  end;

  Result := res;
end;

function TCustomStringGrid.GetRowHeights(ARow: integer): integer;
begin
  if ARow < FRowHeights.Count then
    Result := integer(FRowHeights.Items[ARow])
  else
    Result := DefaultRowHeight;
end;

function TCustomStringGrid.GetSelection: TGridRect;
begin
  Result := FSelection;
end;

function TCustomStringGrid.GetTopRow: integer;
var
  pixVal: integer;
begin
  Result := FixedRows;

  if Assigned(FNormalCells) and (pixVal >= 0) then
  begin
    pixVal := FNormalCells.parentElement.parentElement.scrollTop;

    Result := FixedRows + pixVal div DefaultRowHeight;
  end;
end;

procedure TCustomStringGrid.GridChanged;
begin
  inherited;
  UpdateGridSize;
end;

{$HINTS OFF}
function TCustomStringGrid.HandleCheckBoxClick(Event: TJSEvent): Boolean;
var
  rindex, cindex: integer;
  chk: boolean;
begin
  rindex := -1;
  cindex := -1;

  asm
    var el = Event.target;
    chk = el.checked;
    var d = el.parentElement;
    if (d.tagName.toLowerCase() == 'td')
    {
      cindex = d.cellIndex;
      var tr = d.parentElement;
      rindex = tr.rowIndex;
    }
  end;

  if (rindex <> -1) and (cindex <> -1) then
  begin
    DoCheckClick(cindex + FixedCols, rindex + FixedRows, chk);
  end;
end;

function TCustomStringGrid.HandleFixedClick(Event: TJSEvent): Boolean;
var
  rindex,cindex: integer;
  rselect: boolean;
  tbl: TJSHTMLElement;
  ACol,ARow: integer;

begin
  Result := true;

  rselect := (goRowSelect in Options);
  rindex := -1;
  cindex := -1;

  asm
    if (Event.target.tagName.toLowerCase() == 'td')
    {
      cindex = Event.target.cellIndex;
      var tr = Event.target.parentElement;
      rindex = tr.rowIndex;
      tbl = tr.parentElement;
      tbl = tbl.parentElement;
    }
  end;

  if (cindex = -1) or (rindex = -1) then
    Exit;

  ACol := cindex;
  ARow := rindex;

  if tbl = FFixedCol then
  begin
    ARow := rindex + FixedRows;
  end;

  if tbl = FFixedRow then
  begin
    ACol := cindex + FixedCols;
  end;

  if Assigned(OnFixedCellClick) then
    OnFixedCellClick(Self, ACol, ARow);
end;

function TCustomStringGrid.HandleClick(Event: TJSEvent): Boolean;
var
  rindex,cindex: integer;
  rselect: boolean;

begin
  Result := true;

  rselect := (goRowSelect in Options);
  rindex := -1;
  cindex := -1;

  asm
    if (Event.target.tagName.toLowerCase() == 'td')
    {
      cindex = Event.target.cellIndex;
      var tr = Event.target.parentElement;
      rindex = tr.rowIndex;
    }
  end;

  if (cindex = -1) or (rindex = -1) then
    Exit;

  if not CanSelect(cindex, rindex) then
  begin
    Exit;
  end;

  SelectCell(cindex + FixedCols, rindex+ FixedRows);

  if Assigned(FSelectedCell) then
  begin
    if FSelMouseDown then
    begin
      if (goEditing in Options) then
        ShowEdit;
    end
    else
    asm
      if (rselect) {
        var colindex = this.FSelectedCell.cellIndex;
        var tr = this.FSelectedCell.parentElement;
        tr.classList.remove("selected");
      }
      else {
      this.FSelectedCell.classList.remove("selected");
      }
    end;
  end;

  asm
    if (Event.target.tagName.toLowerCase() == 'td')
    {
      var colindex = Event.target.cellIndex;
      var tr = Event.target.parentElement;
      var rowindex = tr.rowIndex;
      this.FSelectedCell = Event.target;

      if (rselect) {
        tr.classList.add("selected");
      }
      else {
      Event.target.classList.add("selected");
      }
    }
  end;
end;

function TCustomStringGrid.HandleDoMouseMove(Event: TJSMouseEvent): Boolean;
var
  CtrlName: string;
  IsAutoWidth: Boolean;
begin
  inherited;

  CtrlName := GetID;
  IsAutoWidth := (WidthStyle in [ssAuto]);
  asm
    TMSStringGridID = CtrlName;
    TMSStringGridautoWidth = IsAutoWidth;
    GridNormalCells = this.FNormalCells;
    GridFixedCells = this.FFixedRow;
    GridFixedColCells = this.FFixedCol;
    GridFixedColRows = this.FFixedColRow;
    GridColWidths = this.FColWidths;
    GridFixedCols = this.FFixedCols;
    TMSStringGridresizeColumn(Event);
  end;

  Result := True;
end;

function TCustomStringGrid.HandleDoMouseUp(Event: TJSMouseEvent): Boolean;
begin
  inherited;

  asm
    TMSStringGridresetResize();
  end;

  Result := True;
end;

{$HINTS ON}

function TCustomStringGrid.HandleEditBlur(Event: TJSEvent): Boolean;
begin
  if FEditMode then
  begin
    HideEdit;
  end;
  Result := true;
end;

function TCustomStringGrid.HandleEditKeyPress(Event: TJSKeyboardEvent): boolean;
begin
  Event.cancelBubble := true;
  Event.stopPropagation;
  Result := true;
end;

function TCustomStringGrid.HandleKeyDown(Event: TJSKeyboardEvent): boolean;
var
  k: Word;
  newcol,newrow: integer;
begin
  Result := true;

  Event.cancelBubble := true;

  Event.StopPropagation;

  k := GetKeyCode(Event.Key);

  newrow := Row;
  newcol := Col;

  if (newrow = -1) and (newcol = -1) and (ColCount > FixedCols) and (RowCount > FixedRows) then
  begin
    newcol := FixedCols;
    newrow := FixedRows;
    Col := FixedCols;
    Row := FixedRows;
    TJSHTMLElement(FNormalCells).focus;
  end;

  //ss := GetKeyboardEventShiftState(Event);

  // Up, Down, PageUp, PageDn
  if (k in [38, 40, 33, 34]) then
  begin
    Event.preventDefault;
    HideEdit;
    ChangeRow;
  end;

  // Home, End, Left, Right should only work when not in edit mode
  if not EditMode and (k in [35, 36, 37, 39]) then
  begin
    Event.preventDefault;
    HideEdit;
  end;

  // ESC
  if (k = 27) then
  begin
    if Assigned(FEdit) and EditMode then
      (FEdit as TJSHTMLInputElement).value := FOrigVal;
    HideEdit;
  end;

  if not EditMode and Event.shiftKey and (goRangeSelect in Options) then
  begin
    // End
    if (k = 35) then
    begin
      Row := RowCount - 1;
      Selection := GridRect(Col, newrow, Col, Row);
    end;

    // Home
    if (k = 36) then
    begin
      Row := FixedRows;
      Selection := GridRect(Col, newrow, Col, Row);
    end;

    // arrow Up
    if (k = 38) and (Row > FixedRows) then
    begin
      if Row = min(Selection.Top, Selection.Bottom) then
        newrow := max(Selection.Top, Selection.Bottom)
      else
        newrow := min(Selection.Top, Selection.Bottom);

      Row := Row - 1;
      Selection := GridRect(Selection.Left, newrow, Selection.Right, Row);
    end;

    // arrow Down
    if (k = 40) and (Row < RowCount - 1) then
    begin
      if Row = max(Selection.Top, Selection.Bottom) then
        newrow := min(Selection.Top, Selection.Bottom)
      else
        newrow := max(Selection.Top, Selection.Bottom);

      Row := Row + 1;
      Selection := GridRect(Selection.Left, newrow, Selection.Right, Row);
    end;

    // arrow Left
    if (k = 37) and (Col > FixedCols) then
    begin
      if Col = min(Selection.Left, Selection.Right) then
        newcol := max(Selection.Left, Selection.Right)
      else
        newcol := min(Selection.Left, Selection.Right);

      Col := Col - 1;
      Selection := GridRect(newcol, Selection.Top, Col, Selection.Bottom);
    end;

    // arrow Right
    if (k = 39) and (Col < ColCount - 1) then
    begin
      if Col = max(Selection.Left, Selection.Right) then
        newcol := min(Selection.Left, Selection.Right)
      else
        newcol := max(Selection.Left, Selection.Right);

      Col := Col + 1;

      Selection := GridRect(newcol, Selection.Top, Col, Selection.Bottom);
    end;
  end
  else
  begin
    // End
    if (k = 35) then
    begin
      newrow := RowCount - 1;
    end;

    // Home
    if (k = 36) then
    begin
      newrow := FixedRows;
    end;

    // PgUp
    if (k = 34) then
    begin
      if (Row + 4 <= RowCount - 1) then
      begin
        newrow := Row + 4;
      end
      else
      begin
        newrow := RowCount - 1;
      end;
    end;

    // PgDn
    if (k = 33) then
    begin
      if Row - 4 > FixedRows then
      begin
        newrow := Row - 4
      end
      else
      begin
        newrow := FixedRows;
      end;
    end;

    // arrow Up
    if not EditMode and (k = 38) and (Row > FixedRows) then
    begin
      newrow := Row - 1;
    end;

    // arrow Down
    if not EditMode and (k = 40) and (Row < RowCount - 1) then
    begin
      newrow := Row + 1;
    end;

    // arrow Left
    if not EditMode and (k = 37) and (Col > FixedCols) then
    begin
      newcol := Col - 1;
    end;

    // arrow Right
    if not EditMode and (k = 39) and (Col < ColCount - 1) then
    begin
      newcol := Col + 1;
    end;

    if not EditMode and CanSelect(newcol,newrow) then
    begin
      Col := newcol;
      Row := newrow;

      SelectCell(newcol,newrow);
    end;

    if (k = 113) and not EditMode and (goEditing in Options) then
      ShowEdit;

    if (k >= 48) and (k <= 122) and not EditMode then
      StartEdit(Event.Key);

    if (k = 13) and (goEditing in Options) then
    begin
      if EditMode then
      begin
        HideEdit;
      end
      else
        ShowEdit;
    end;
  end;
end;

function TCustomStringGrid.HandleMouseDown(Event: TJSMouseEvent): Boolean;
var
  rindex, cindex: integer;
  l, t: Single;
  ss: TShiftState;
  mb: TMouseButton;
begin
  rindex := -1;
  cindex := -1;

  asm
    if (Event.target.tagName.toLowerCase() == 'td')
    {
      cindex = Event.target.cellIndex;
      var tr = Event.target.parentElement;
      rindex = tr.rowIndex;
    }
  end;

  FSelMouseDown := Event.target = FSelectedCell;

  if Assigned(FSelectedCell) and not FSelMouseDown and (cindex <> -1) and (rindex <> -1) then
  begin
    HideEdit;
  end;

  if not CanSelect(cindex, rindex) then
    Exit;

  if (cindex >= 0) and (rindex >= 0) then
  begin
    if (goRowSelect in Options) then
      Selection := GridRect(FixedCols, rindex + FixedRows, ColCount - 1, rindex + FixedRows)
    else
      Selection := GridRect(cindex + FixedCols, rindex + FixedRows, cindex + FixedCols, rindex + FixedRows);

    if (goRangeSelect in Options) then
    begin
      FStartCell.X := cindex + FixedCols;
      FStartCell.Y := rindex + FixedRows;
    end
    else
    begin
      FStartCell.X := -1;
      FStartCell.Y := -1;
    end;
  end;

  XYToClient(Event.clientX, Event.clientY, l, t);

  ss := GetMouseEventShiftState(Event);
  mb := GetMouseEventButton(Event);

  MouseDown(mb, ss, Trunc(l), Trunc(t));

  Result := true;
end;

function TCustomStringGrid.HandleScroll(Event: TJSEvent): Boolean;
begin
  if FixedCols > 0 then
    FFixedCol.parentElement.scrollTop := FNormalCells.parentElement.parentElement.scrollTop;

  if FixedRows > 0 then
    FFixedRow.parentElement.parentElement.scrollLeft := FNormalCells.parentElement.parentElement.scrollLeft;

  TopLeftChanged;

  Result := true;
end;

function TCustomStringGrid.HandleTableFocus(Event: TJSEvent): Boolean;
begin
  if (Col = -1) and (Row = -1) and (FixedCols < ColCount) and (FixedRows < RowCount) and CanSelect(FixedCols, FixedRows) then
  begin
    SelectCell(FixedCols, FixedRows);
  end;
  Result := true;
end;

procedure TCustomStringGrid.HideEdit;
var
  val: string;
begin
  if EditMode then
  begin
    FEditMode := false;

    val := (FEdit as TJSHTMLInputElement).value;

    ValidateCell(FEditCol, FEditRow, val);

    FSelectedCell.removeChild(FEdit);
    FSelectedCell.innerHTML := val;

    UpdateCell(FEditCol, FEditRow, val);

    SetEditText(FEditCol, FEditRow, val);

    TJSHTMLElement(FNormalCells).focus();
  end;
end;

procedure TCustomStringGrid.InitSample(AInitMethod: TInitMethod);
var
  i,j: integer;
begin
  for i := 0 to RowCount - 1 do
  begin
    for j := 0 to ColCount - 1 do
    begin
     case AInitMethod of
     imRandom:
       Cells[j,i] := IntToStr(Random(100));
     imLinear:
       Cells[j,i] := IntToStr(j)+':'+IntToStr(i);
     end;
    end;
  end;
end;

procedure TCustomStringGrid.MouseToCell(X,Y: integer; var C, R: integer);
var
  DocX,DocY: single;
  el: TJSHTMLElement;
  cindex,rindex: integer;
begin
  C := -1;
  R := -1;

  ClientToXY(X,Y,DocX,DocY);

  el := TJSHTMLElement(document.elementFromPoint(Round(DocX),Round(DocY)));

  if Assigned(el) then
  begin
    asm
      if (el.tagName.toLowerCase() == 'td')
      {
        cindex = el.cellIndex;
        var tr = el.parentElement;
        rindex = tr.rowIndex;

        if (tr.parentElement.parentElement == this.FNormalCells)
        {
          rindex = rindex + this.FFixedRows;
          cindex = cindex + this.FFixedCols;
        }
        if (tr.parentElement.parentElement == this.FFixedCol)
        {
          rindex = rindex + this.FFixedRows;
        }
        if (tr.parentElement.parentElement == this.FFixedRow)
        {
          cindex = cindex + this.FFixedCols;
        }
      }
    end;

    R := rindex;
    C := cindex;
  end;

end;

procedure TCustomStringGrid.LoadFromCSV(const AURL: string; Delimiter: char = ';'; LoadFixed: boolean = false);
begin
  FDelimiter := Delimiter;
  FLoadFixed := LoadFixed;

  FReq := TJSXMLHttpRequest.new;
  FReq.addEventListener('load',@DoHttpLoadCsv);
  FReq.addEventListener('abort',@DoHttpAbort);
  DoHttpRequest(FReq);
  FReq.open('GET', AURL);
  FReq.send;
end;

procedure TCustomStringGrid.LoadFromJSON(const AURL: string; ADataNode: string = '');
begin
  FDataNode := ADataNode;
  FReq := TJSXMLHttpRequest.new;
  FReq.addEventListener('load',@DoHttpLoadJson);
  FReq.addEventListener('abort',@DoHttpAbort);
  DoHttpRequest(FReq);
  FReq.open('GET', AURL);
  FReq.send;
end;

procedure TCustomStringGrid.MouseMove(Shift: TShiftState; X, Y: Integer);
begin
  inherited;
  if (FStartCell.X <> -1) and (FStartCell.Y <> -1) then
  begin
    if (Y > Height - 10) then
    begin
      TopRow := TopRow + 1;
      Selection := GridRect(Selection.Left, min(Selection.Top, Selection.Bottom), Selection.Right, max(Selection.Top, Selection.Bottom) + 1);
    end;

    if (FixedRows > 0) and (Y < RowHeights[0]) and (TopRow > FixedRows) then
    begin
      TopRow := TopRow - 1;
      Selection := GridRect(Selection.Left, min(Selection.Top, Selection.Bottom) - 1, Selection.Right, max(Selection.Top, Selection.Bottom));
    end;

    if (X > Width - 10) then
    begin
      LeftCol := LeftCol + 1;
      Selection := GridRect(min(Selection.Left, Selection.Right), Selection.Top, max(Selection.Left, Selection.Right) + 1, Selection.Bottom);
    end;

    if (FixedCols > 0) and (X < ColWidths[0]) and (LeftCol > FixedCols) then
    begin
      LeftCol := LeftCol - 1;
      Selection := GridRect(min(Selection.Left, Selection.Right) - 1, Selection.Top, max(Selection.Left, Selection.Right), Selection.Bottom);
    end;

  end;
end;

function TCustomStringGrid.NormalColWidth: integer;
var
  i: integer;
begin
  Result := 1;

  for i := FixedCols to ColCount - 1 do
    Result := Result + ColWidths[i] + 1;
end;

function TCustomStringGrid.NormalRowHeight: integer;
var
  i: integer;
begin
  Result := 0;

  for i := FixedRows to RowCount - 1 do
    Result := Result + RowHeights[i];
end;


{$HINTS OFF}
procedure TCustomStringGrid.RenderGrid;
var
  res: TJSHTMLElement;
  i,j,k,fw,fh,nw,nh,nwvis,nhvis,nwvisnoscroll,nhvisnoscroll: integer;
  tr, td, span, cellspan: TJSElement;
  fixcol: string;
  dynstyle: string;
  vscroll,hscroll: boolean;
  LAutoSizeW: boolean;
  ControlName: string;
begin
  while FColWidths.Count <= ColCount do
    FColWidths.Add(DefaultColWidth);

  if not Assigned(FGrid) then
  begin
    if IsLinked then
      res := TJSHTMLElement(ElementHandle.firstChild)
    else
      res := TJSHTMLElement(document.createElement('TABLE'));

    res.setAttribute('id', GetID);
    res.setAttribute('class','tstringgrid');
    res.style.setProperty('border-collapse','collapse');
    res.style.setProperty('border-spacing','0px');
    res.style.setProperty('border','0px');
    FGrid := res;

    SetHTMLElementFont(res, Font, not ((ElementClassName = '') and (ElementFont = efProperty)) );

    AddInstanceStyle(GetGridCSS);
  end
  else
    Exit;

  LAutoSizeW := WidthStyle = ssAuto;
  ControlName := GetID;

  asm
    var td = undefined;
    var tr = undefined;
    var span = undefined;
    var cellspan = undefined;
    this.FFixedColRow = document.createElement('TABLE');
    this.FFixedColRow.setAttribute('id', ControlName + 'ResizeFixedRowTable');
    this.FFixedColRow.style.setProperty('border-collapse','collapse');
    this.FFixedColRow.style.setProperty('border-spacing','0px');

    this.FFixedCol = document.createElement('TABLE');
    this.FFixedCol.setAttribute('id', ControlName + 'ResizeFixedColTable');
    this.FFixedCol.style.setProperty('border-collapse','collapse');
    this.FFixedCol.style.setProperty('border-spacing','0px');

    this.FFixedRow = document.createElement('TABLE');
    this.FFixedRow.setAttribute('id', ControlName + 'ResizeRowTable');
    this.FFixedRow.style.setProperty('border-collapse','collapse');
    this.FFixedRow.style.setProperty('border-spacing','0px');
    this.FFixedRow.style.setProperty('border','0px');

    this.FNormalCells = document.createElement('TABLE');
    this.FNormalCells.setAttribute('id', ControlName + 'ResizeRowTable');
    this.FNormalCells.style.setProperty('border-collapse','collapse');
    this.FNormalCells.style.setProperty('border-spacing','0px');
  end;

  // make normal grid cells focusable
  FNormalCells.setAttribute('tabindex',IntToStr(TabOrder));
  TJSHTMLElement(FNormalCells).style.setProperty('outline','none');
  FNormalCells.addEventListener('click',@HandleClick);
  FNormalCells.addEventListener('mousedown',@HandleMouseDown);
  FNormalCells.addEventListener('mousemove',@HandleMouseMove);
  FNormalCells.addEventListener('mouseup',@HandleMouseUp);

  FFixedCol.addEventListener('click',@HandleFixedClick);
  FFixedRow.addEventListener('click',@HandleFixedClick);
  FFixedColRow.addEventListener('click',@HandleFixedClick);

  ElementHandle.appendChild(res);

  fw := FixedColWidth;
  fh := FixedRowHeight;

  nw := NormalColWidth;
  nh := NormalRowHeight;

  nwvis := Width - FixedColWidth;
  nhvis := Height - FixedRowHeight;

  if BorderStyle = bsSingle then
  begin
    nwvis := nwvis - 2;
    nhvis := nhvis - 2;
  end;

  nwvisnoscroll := nwvis - GetScrollBarWidth;
  nhvisnoscroll := nhvis - GetScrollBarHeight;

  fixcol := ColorToHTML(FFixedColor);

  // insert the main four grid cells
  asm
    tr = res.insertRow(0);
    td = tr.insertCell(0);
    td.style.border = "0px";
    td = tr.insertCell(1);
    td.style.border = "0px";
    tr = res.insertRow(1);
    td = tr.insertCell(0);
    td.style.border = "0px";
    td = tr.insertCell(1);
    td.style.border = "0px";
  end;

  // fill fixedrow cells
  if FixedRows > 0 then
  begin
    k := 0;

    // fixedcol/fixedrow
    if FixedCols > 0 then
    begin
      k := 1;
      asm
        td = res.rows[0].cells[0];
        span = document.createElement('DIV');
//        span.style.width = fw + "px";
        span.style.height = fh + "px";
        span.style.overflow = "hidden";
        span.style.backgroundColor = fixcol;
        td.appendChild(span);
        span.appendChild(this.FFixedColRow);
      end;
    end
    else
    begin
      asm
        td = res.rows[0].cells[0];
        td.style.border = "0px";
        td = res.rows[1].cells[0];
        td.style.border = "0px";
      end;

    end;

    //
    asm
      td = res.rows[0].cells[1];
      td.style.backgroundColor = fixcol;

      span = document.createElement('DIV');
      span.style.height = fh + "px";
      if (!LAutoSizeW) {
        span.style.width = nwvis + "px";
      }

      span.style.overflow = "hidden";
      span.style.backgroundColor = fixcol;

      td.appendChild(span);

      cellspan = document.createElement('DIV');
      cellspan.style.height = fh + "px";
      if (!LAutoSizeW) {
        cellspan.style.width = nw + "px";
      }

      span.appendChild(cellspan);
      cellspan.appendChild(this.FFixedRow);
    end;

    if (FixedCols > 0) then
    begin
      for i := 0 to FixedRows - 1 do
      begin
        asm
          tr = this.FFixedColRow.insertRow(i);
        end;

        for j := 0 to FixedCols - 1 do
        begin
          asm
            td = tr.insertCell(j);
          end;

          //TJSHTMLElement(td).innerHTML := inttostr(j)+':'+inttostr(i);
        end;
      end;
    end;

    // fill top cell
    for i := 0 to FixedRows - 1 do
    begin
      asm
        tr = this.FFixedRow.insertRow(i);
      end;

      for j := FixedCols to ColCount - 1 do
      begin
        k := j - FixedCols;
        asm
          td = tr.insertCell(k);
        end;

        //TJSHTMLElement(td).innerHTML := inttostr(j)+':'+inttostr(i);
      end;
    end;
  end;

  k := 0;

  // fill left cell
  if FixedCols > 0 then
  begin
    k := 1;
    asm
      //tr = res.insertRow(res.rows.length);
      //td = tr.insertCell(0);

      td = res.rows[1].cells[0];

      td.style.backgroundColor = fixcol;

      span = document.createElement('DIV');
      if (!LAutoSizeW) {
      //span.style.width = fw + "px";
      }
      span.style.height = nhvisnoscroll + "px";
      span.style.overflow = "hidden";
      span.style.backgroundColor = fixcol;

      td.setAttribute('valign','top');
      td.appendChild(span);
      span.appendChild(this.FFixedCol);
    end;

    for i := FixedRows to RowCount - 1 do
    begin
      j := i - FixedRows;
      asm
        tr = this.FFixedCol.insertRow(j);
      end;

      for j := 0 to FixedCols - 1 do
      begin
        asm
          td = tr.insertCell(j);
        end;

        //TJSHTMLElement(td).innerHTML := inttostr(j)+':'+inttostr(i);
      end;
    end;
  end;

  if FixedCols = 0 then
  begin
    asm
      //tr = res.insertRow(res.rows.length);
      //td = tr.insertCell(0);
      td = res.rows[1].cells[1];
    end
  end
  else
  begin
    asm
      //tr = res.rows[1];
      //td = tr.insertCell(1);
      td = res.rows[1].cells[1];
    end;
  end;

  vscroll := (ssVertical = ScrollBars) or (ssBoth = ScrollBars);
  hscroll := (ssHorizontal = ScrollBars) or (ssBoth = ScrollBars);

  asm
    span = document.createElement('DIV');
    span.style.backgroundColor = "#FFFFFF";
    if (vscroll) {
      span.style.overflowY = "auto";
    }
    else
    {
      span.style.overflowY = "hidden";
    }

    if (hscroll) {
      span.style.overflowX = "auto";
    }
    else {
      span.style.overflowX = "hidden";
    }
    if (!LAutoSizeW) {
      span.style.width = nwvis + "px";
    }
    span.style.height = nhvis + "px";
    td.appendChild(span);

    cellspan = document.createElement('DIV');
      if (!LAutoSizeW) {
        cellspan.style.width = nw + "px"; }
    cellspan.style.height = nh + "px";
    span.parentElement.style.verticalAlign = "top";
    span.appendChild(cellspan);
    cellspan.appendChild(this.FNormalCells);
  end;

  span.addEventListener('scroll',@HandleScroll);

  for i := FixedRows to RowCount - 1 do
  begin
    k := i - FixedRows;
    asm
      tr = this.FNormalCells.insertRow(k);
    end;

    for j := FixedCols to ColCount - 1 do
    begin
      k := j - FixedCols;

      asm
        td = tr.insertCell(k);
      end;
    end;
  end;

  FNormalCells.parentElement.parentElement.addEventListener('keydown',@HandleKeydown);
  FNormalCells.addEventListener('focus',@HandleTableFocus);

  EnableColResize;
end;

procedure TCustomStringGrid.RenderGridScript;
begin
  AddControlScriptSource(
  'var TMSStringGridpageX,TMSStringGridcurCol,TMSStringGridnxtCol,TMSStringGridcurColWidth,TMSStringGridnxtColWidth,TMSStringGridautoWidth,GridNormalCells,GridFixedCells,GridFixedColCells,GridFixedColRows,GridColWidths,GridFixedCols,TMSStringGridCurID;'+
  'var TMSStringGridTable,TMSStringGridcurTableWidth,TMSStringGridID,TMSStringGridFullWidth;'+
  'TMSStringGridautoWidth = false;'+
  'TMSStringGridCurID = "";'+
  'ResizeMainGrid = true;'+

  'function TMSStringGridupdateColSize(Cells, Col) {'+
  '    if (Cells){'+
  '     for (i = 0; i < Cells.rows.length; i++){'+
  '       td = Cells.rows[i].cells[Col.cellIndex];'+
  '       td.style.position = "relative";'+
  '       td.style.width = Col.style.width;'+
  '       td.style.maxWidth = Col.style.width;'+
  '      }'+
  '    }'+
  '}'+

  'function TMSStringGridresizeColumn(e) {'+
  '   if ((TMSStringGridcurCol) && (TMSStringGridCurID.indexOf(TMSStringGridID) == 0)) {'+

  '    var diffX = e.pageX - TMSStringGridpageX;'+

  '    newColWidth = (TMSStringGridcurColWidth + diffX);'+
  '    if (newColWidth < 10)'+
  '      newColWidth = 10;'+

  '    if (TMSStringGridCurID.indexOf("ResizeRow") > 0) {'+
  //resize normal columns
  '	    TMSStringGridcurCol.style.width = newColWidth + "px";'+
  '	    TMSStringGridcurCol.style.maxWidth = TMSStringGridcurCol.style.width;'+
  '     GridColWidths.Put(TMSStringGridcurCol.cellIndex + GridFixedCols, parseInt(TMSStringGridcurCol.style.width));'+
  '     TMSStringGridupdateColSize(GridFixedCells, TMSStringGridcurCol);'+
  '     TMSStringGridupdateColSize(GridNormalCells, TMSStringGridcurCol);'+

  '     TMSStringGridcurTable.style.width = (TMSStringGridcurTableWidth + diffX) + "px";'+
  '     GridNormalCells.style.width = (TMSStringGridcurTableWidth + diffX) + "px";'+
  '    } else {'+
  //resize fixed columns
  '     TMSStringGridfullWidth = document.getElementById(TMSStringGridID).offsetWidth;'+
  '     newCellsWidth = (TMSStringGridfullWidth - (TMSStringGridcurTableWidth + diffX));'+

  '     if ((newCellsWidth > 10) && (newColWidth > 10)) {'+
  '	     TMSStringGridcurCol.style.width = newColWidth + "px";'+
  '	     TMSStringGridcurCol.style.maxWidth = TMSStringGridcurCol.style.width;'+
  '      TMSStringGridupdateColSize(GridFixedColRows, TMSStringGridcurCol);'+
  '      TMSStringGridupdateColSize(GridFixedColCells, TMSStringGridcurCol);'+

  '      TMSStringGridcurTable.style.width = (TMSStringGridcurTableWidth + diffX) + "px";'+
  '      GridFixedColCells.style.width = (TMSStringGridcurTableWidth + diffX) + "px";'+

  '      if ((!TMSStringGridautoWidth) && (newColWidth > 10)){' +
  '       GridFixedCells.parentElement.style.width = newCellsWidth + "px";'+
  '       GridFixedCells.parentElement.parentElement.style.width = newCellsWidth + "px";'+

  '       GridNormalCells.parentElement.style.width = newCellsWidth + "px";'+
  '       GridNormalCells.parentElement.parentElement.style.width = newCellsWidth + "px";'+
  '      }'+
  '     }'+
  '    }'+
  '   }'+
  ' }'+

  'function TMSStringGridresetResize() {'+
  '   TMSStringGridID = "";'+
  '   TMSStringGridFullWidth = undefined;'+
  '   TMSStringGridCurID = "";'+
  '   TMSStringGridcurCol = undefined;'+
  '   TMSStringGridnxtCol = undefined;'+
  '   TMSStringGridpageX = undefined;'+
  '   TMSStringGridnxtColWidth = undefined;'+
  '   TMSStringGridcurColWidth = undefined;'+
  '   TMSStringGridautoWidth = false;'+
  '   GridFixedCells = undefined;'+
  '   GridFixedColCells = undefined;'+
  '   GridFixedColRows = undefined;'+
  '   GridNormalCells = undefined;'+
  '   GridColWidths = undefined;'+
  '   GridFixedCols = undefined;'+
  ' }'+

  'function TMSStringGridresizableGrid(tablename, enabled) {'+
  ' var table = document.getElementById(tablename + "Table");'+
  ' if (!table) return;' +
  ' var row = table.getElementsByTagName("tr")[0],'+
  ' cols = row ? row.children : undefined;'+
  ' if (!cols) return;'+

  ' for (var i=0;i<cols.length;i++){'+
  '  var coldiv = document.getElementById(tablename + "Div" + i);'+

  '  if (coldiv)'+
  '    coldiv.remove();'+

  '  if (enabled) {'+
  '    var div = createDiv();'+
  '    cols[i].appendChild(div);'+
  '    cols[i].style.position = "relative";'+
  '    div.id = tablename + "Div" + i;'+
  '    setListeners(div);'+
  '  }'+
  ' }'+

  ' function setListeners(div){'+

  '  div.addEventListener("mousedown", function (e) {'+
  '   TMSStringGridCurID = e.target.id;'+
  '   TMSStringGridcurCol = e.target.parentElement;'+
  '   TMSStringGridnxtCol = TMSStringGridcurCol.nextElementSibling;'+
  '   TMSStringGridpageX = e.pageX;'+

  '   TMSStringGridcurTable = TMSStringGridcurCol.parentElement.parentElement.parentElement;'+
  '   TMSStringGridcurTableWidth = TMSStringGridcurTable.offsetWidth;'+

  '   TMSStringGridcurColWidth = TMSStringGridcurCol.offsetWidth;'+
  '   if (TMSStringGridnxtCol)'+
  '    TMSStringGridnxtColWidth = TMSStringGridnxtCol.offsetWidth;'+
  '  });'+

  '  div.addEventListener("mouseover", function (e) {'+
  '   e.target.style.borderRight = "2px solid #0000ff";'+
  '  });'+

  '  div.addEventListener("mouseout", function (e) {'+
  '   e.target.style.borderRight = "";'+
  '  });'+

  '  document.addEventListener("mousemove", function (e) {'+
  '   TMSStringGridresizeColumn(e);'+
  '  });'+

  '  document.addEventListener("mouseup", function (e) {'+
  '   TMSStringGridresetResize();'+
  '  });'+
  ' }'+

  ' function createDiv(){'+
  '  var div = document.createElement("div");'+
  '  div.style.top = 0;'+
  '  div.style.right = 0;'+
  '  div.style.width = "10px";'+
  '  div.style.position = "absolute";'+
  '  div.style.cursor = "col-resize";'+
  '  div.style.userSelect = "none";'+
  '  div.style.height = "100%";'+
//  '  div.style.border = "1px solid red";'+
  '  div.innerHTML = "&nbsp;";'+
  '  return div;'+
  ' }'+

  '};');
end;

procedure TCustomStringGrid.RenderGridSize;
var
  fw,fh,nw,nh,nwvis,nhvis,nwvisnoscroll,nhvisnoscroll: integer;

begin
  if not Assigned(FGrid) then
    Exit;

  fw := FixedColWidth;
  fh := FixedRowHeight;

  nw := NormalColWidth;
  nh := NormalRowHeight;

  nwvis := Width - FixedColWidth;
  nhvis := Height - FixedRowHeight;

  if BorderStyle = bsSingle then
  begin
    nwvis := nwvis - 2;
    nhvis := nhvis - 2;
  end;

  nwvisnoscroll := nwvis - GetScrollBarWidth;
  nhvisnoscroll := nhvis - GetScrollBarHeight;

  if (FixedRows > 0) and (WidthStyle = ssAbsolute) then
  begin
    asm
      var td = this.FGrid.rows[0].cells[1];
      if (td!=null) {
      var span = td.firstChild;
      span.style.width = nwvisnoscroll + "px";
      span.style.overflow = "hidden";
      }
    end;
  end;

  if (FixedCols > 0) and (HeightStyle = ssAbsolute) then
  begin
    asm
      var td = this.FGrid.rows[1].cells[0];
      if (td!=null) {
      var span = td.firstChild;
      span.style.height = nhvisnoscroll + "px";
      span.style.overflow = "hidden";
      }
    end;
  end;
end;

procedure TCustomStringGrid.Resize;
begin
  inherited;
  RenderGridSize;
end;

procedure TCustomStringGrid.RowCountChanged(delta: integer);
var
  r: integer;
  fr,fc: integer;
begin
  if IsUpdating then
    Exit;

  fr := FixedRows;
  fc := FixedCols;

  if delta > 0 then
  begin
    asm
      var i = 0;
      var j = 0;
      var tr = undefined;
      var td = undefined;
      var l = this.FNormalCells.rows.length;

      for(i = 0;i < delta; i++)
      {
         tr = this.FNormalCells.insertRow(l);
         for(j = this.FFixedCols; j < this.FColCount; j++)
         {
            td = tr.insertCell(0);
         }

         if (fc > 0) {
           tr = this.FFixedCol.insertRow(l);
           for(j = 0; j < this.FFixedCols; j++)
           {
             tr.insertCell(0);
           }
         }
      }
    end;

    BeginUpdate;

    for r := 1 to delta do
    begin
      RowHeights[RowCount - r] := DefaultRowHeight;
    end;

    EndUpdate;
  end;

  if delta < 0 then
  begin
    asm
      var i = 0;
      var l = this.FNormalCells.rows.length;

      for(i = 0;i < -delta; i++)
      {
        this.FNormalCells.deleteRow(l - i - 1);

        if (fc > 0) {
          this.FFixedCol.deleteRow(l - i - 1);
        }
      }
    end;

    if RowCount > 0 then
      RowHeights[RowCount - 1] := RowHeights[RowCount - 1];
  end;
end;

procedure TCustomStringGrid.SelectCell(ACol, ARow: integer);
var
  rc,rr: integer;
begin
  Selection := GridRect(ACol, ARow, ACol, ARow);

  rc := ACol - FixedCols;
  rr := ARow - FixedRows;

  asm
    this.FSelectedCell = this.FNormalCells.rows[rr].cells[rc];
  end;

end;

procedure TCustomStringGrid.SetCells(ACol, ARow: integer; const Value: string);
var
  rc,rr: integer;
begin
  if (ACol < FixedCols) and (ARow >= FixedRows) then
  begin
    rr := ARow - FixedRows;
    rc := ACol;

    asm
      var td = this.FFixedCol.rows[rr].cells[rc];
      td.innerHTML = Value;
    end;
  end;

  if (ARow < FixedRows) and (ACol >= FixedCols) then
  begin
    rc := ACol - FixedCols;
    rr := ARow;

    asm
      var td = this.FFixedRow.rows[rr].cells[rc];
      td.innerHTML = Value;
    end;
  end;

  if (ACol < FixedCols) and (ARow < FixedRows) then
  begin
    rc := ACol;
    rr := ARow;

    asm
      var td = this.FFixedColRow.rows[rr].cells[rc];
      td.innerHTML = Value;
    end;
  end;

  if (ACol >= FixedCols) and (ARow >= FixedRows) then
  begin
    rc := ACol - FixedCols;
    rr := ARow - FixedRows;
    asm
      var td = this.FNormalCells.rows[rr].cells[rc];
      td.innerHTML = Value;
    end;
  end;

  if ARow = 0 then
    EnableColResize;
end;

procedure TCustomStringGrid.SetCol(const Value: integer);
var
  r,c: integer;
begin
  if (Value < ColCount) and (Value >= FixedCols) then
  begin
     if Assigned(FSelectedCell) then
     begin
       asm
         this.FSelectedCell.classList.remove("selected");
       end;
     end;

     c := Value - FixedCols;
     r := Row - FixedRows;
     if r < 0 then
       r := 0;

     asm
       var tr = this.FNormalCells.rows[r];
       var td = tr.cells[c];
       td.classList.add("selected");
       this.FSelectedCell = td;

       var pardiv = this.FNormalCells.parentElement.parentElement;

       if (td.offsetLeft < pardiv.scrollLeft) {
         pardiv.scrollLeft = td.offsetLeft;
       }

       if (td.offsetLeft + td.offsetWidth - pardiv.scrollLeft > pardiv.offsetWidth) {
         pardiv.scrollLeft = pardiv.scrollLeft + td.offsetWidth;
       }
     end;
  end;
end;

procedure TCustomStringGrid.SetColWidths(ACol: integer; const Value: integer);
var
  fcw: integer;
  nw, nwvis, nwvisnoscroll: integer;
  LAutoSizeW: boolean;
begin
  while FColWidths.Count <= ACol do
    FColWidths.Add(DefaultColWidth);

  FColWidths[ACol] := Value;

  if IsUpdating then
    Exit;

  if not Assigned(FGrid) then
    Exit;

  LAutoSizeW := WidthStyle = ssAuto;
  nw := NormalColWidth;
  nwvis := Width - FixedColWidth;
  nwvisnoscroll := nwvis - GetScrollBarWidth;

  if ACol < FixedCols then
  begin
    fcw := FixedColWidth;
    asm
      var tr = this.FGrid.rows[0];
      if (tr != undefined) {
      var td = tr.cells[0];
      if (td != undefined) {
        td.style.width = fcw + "px";
        if (td.firstChild != undefined) {
        td.firstChild.style.width = fcw + "px"; }
        }
      }

      tr = this.FGrid.rows[1];
      if (tr != undefined) {
      td = tr.cells[0];
      if (td != undefined) {
        td.style.width = fcw + "px";
        if (td.firstChild != undefined) {
        td.firstChild.style.width = fcw + "px"; }
        }

      tr = this.FFixedColRow.rows[0];
      if (tr != undefined) {

      td = tr.cells[0];
      if (td != undefined) {
        td.style.width = fcw + "px";
        }
        }
      }
      tr = this.FFixedCol.rows[0];
      if (tr != undefined) {

      td = tr.cells[0];
      if (td != undefined) {
        td.style.width = fcw + "px";
        }
      }
    end;
  end;

  if ACol >= FixedCols then
  begin
    ACol := ACol - FixedCols;

    asm
      var tr = this.FFixedRow.rows[0];
      if (tr != undefined) {
        var td = tr.cells[ACol];
        td.style.width = Value + "px";
        td.style.maxwidth = Value + "px";

        if (this.FNormalCells.rows.length > 0)
        {
        var td = this.FNormalCells.rows[0].cells[ACol];
        td.style.width = Value + "px";
        td.style.maxwidth = Value + "px";
        }
      }
    end;
  end;

  asm
    var tr = this.FGrid.rows[0];
    if (tr != undefined) {
      var td = tr.cells[1];
      if ((td.firstChild != undefined) && (!LAutoSizeW)) {
      td.firstChild.style.width = nwvisnoscroll + "px";
      td.firstChild.firstChild.style.width = nw + "px";
      }
    }
    tr = this.FGrid.rows[1];
    if (tr != undefined) {
      td = tr.cells[1];
      if ((td.firstChild != undefined) && (!LAutoSizeW)) {
      td.firstChild.style.width = nwvis + "px";
      td.firstChild.firstChild.style.width = nw + "px";
      }
    }
  end;

  UpdateGridSize;
end;
{$HINTS ON}


procedure TCustomStringGrid.SetDefaultColWidth(const Value: integer);
var
  i: integer;
begin
  FDefaultColWidth := Value;

  for i := 0 to ColCount - 1 do
    ColWidths[i] := Value;
end;

procedure TCustomStringGrid.SetDefaultRowHeight(const Value: integer);
var
  i: integer;
begin
  FDefaultRowHeight := Value;
  for i := 0 to RowCount - 1 do
    RowHeights[i] := Value;
end;

procedure TCustomStringGrid.SetEditText(ACol, ARow: Longint;
  const AValue: string);
begin
  if Assigned(OnSetEditText) then
    OnSetEditText(Self, ACol, ARow, AValue);
end;

procedure TCustomStringGrid.SetFixedColor(const Value: TColor);
begin
  if (FFixedColor <> Value) then
  begin
    FFixedColor := Value;
    UpdateElementVisual;
  end;
end;

procedure TCustomStringGrid.SetFixedCols(const Value: integer);
begin
  if (FFixedCols <> Value) then
  begin
    FFixedCols := Value;

    if not IsUpdating then
    begin
      FGrid.removeChild(FGrid.firstChild);
      FGrid := nil;
      RenderGrid;
      UpdateGridSize;
    end;
  end;
end;

procedure TCustomStringGrid.SetFixedRows(const Value: integer);
begin
  if (FFixedRows <> Value) then
  begin
    FFixedRows := Value;

    if not IsUpdating then
    begin
      FGrid.removeChild(FGrid.firstChild);
      FGrid := nil;
      RenderGrid;
      UpdateGridSize;
    end;
  end;
end;

procedure TCustomStringGrid.SetFocus;
begin
  inherited;
end;

procedure TCustomStringGrid.SetLeftCol(const Value: integer);
var
  i,w: integer;
begin
  w := 0;
  for i := FixedCols to Value - 1 do
    w := w + ColWidths[i]+1;

  if Assigned(FNormalCells) then
  begin
    FNormalCells.parentElement.parentElement.scrollLeft := w;
    if FixedCols > 0 then
      FFixedCol.parentElement.parentElement.scrollLeft := w;
  end;
end;

{$HINTS OFF}
procedure TCustomStringGrid.SetRow(const Value: integer);
var
  r,c,sh: integer;
  rselect: boolean;

begin
  if (Value < RowCount) and (Value >= FixedRows) then
  begin
     rselect := (goRowSelect in Options);

     if Assigned(FSelectedCell) and rselect then
     begin
       asm
         var colindex = this.FSelectedCell.cellIndex;
         var tr = this.FSelectedCell.parentElement;
         tr.classList.remove("selected");
       end;
     end;

     if Assigned(FSelectedCell) then
     begin
       asm
         this.FSelectedCell.classList.remove("selected");
       end;
     end;

     c := Col - FixedCols;
     if c < 0 then
       c := 0;

     r := Value - FixedRows;

     sh := GetScrollBarHeight;

     asm
       var tr = this.FNormalCells.rows[r];
       var td = tr.cells[c];

       if (rselect){
         if (this.FSelectedCell != undefined) {
         this.FSelectedCell.classList.remove("selected"); }
         tr.classList.add("selected");
         this.FSelectedCell = td;
       }
       else
       {
         this.FSelectedCell = td;
         this.FSelectedCell.classList.add("selected");
       }

       var pardiv = this.FNormalCells.parentElement.parentElement;

       if (td.offsetTop < pardiv.scrollTop) {
         pardiv.scrollTop = td.offsetTop;
       }

       while (td.offsetTop + td.offsetHeight - pardiv.scrollTop > pardiv.offsetHeight - sh)  {
         pardiv.scrollTop = pardiv.scrollTop + td.offsetHeight;
       }
     end;
  end;
end;

procedure TCustomStringGrid.SetRowHeights(ARow: integer; const Value: integer);
var
  frh: integer;
  fh, nh, nhvis, nhvisnoscroll: integer;
begin
  while FRowHeights.Count <= ARow do
    FRowHeights.Add(DefaultRowHeight);

  FRowHeights[ARow] := Value;

  if IsUpdating then
    Exit;

  if not Assigned(FGrid) then
    Exit;

  fh := FixedRowHeight;

  nh := NormalRowHeight;

  nhvis := Height - FixedRowHeight;

  nhvisnoscroll := nhvis - GetScrollBarHeight;

  if ARow < FixedRows then
  begin
    frh := FixedRowHeight;
    asm
      var tr = this.FGrid.rows[0];
      if (tr != undefined) {
        tr.style.height = frh + "px";
        var td = tr.cells[0];
        if (td != undefined) {
          var fc = td.firstChild;
          if (fc != undefined) {
            fc.style.height = frh + "px";
          }
          td = tr.cells[1];
          fc = td.firstChild;
          if (fc != undefined) {
            fc.style.height = frh + "px";
          }
          }
        }

      tr = this.FFixedColRow.rows[0];
      if (tr != undefined) {
         tr = tr.cells[0];
         if (tr != undefined) {
         tr.style.height = Value + "px";
         tr = this.FFixedRow.rows[ARow].cells[0];
         if (tr != undefined) {
         tr.style.height = Value + "px"; }
         }
      }
    end;
  end;


  if ARow >= FixedRows then
  begin
    ARow := ARow - FixedRows;

    asm
      var tr = this.FFixedCol.rows[ARow];
      if (tr != undefined) {

      tr.style.height = Value + "px";
      var tr = this.FNormalCells.rows[ARow];
      if (tr != undefined) {
      tr.style.height = Value + "px"; }
      }
    end;
  end;

  asm
    var td = this.FGrid.rows[1].cells[0];
    if (td.firstChild) {

    td.firstChild.style.height = nhvisnoscroll + "px";
    td.firstChild.firstChild.style.height = nh + "px";
    }

    td = this.FGrid.rows[1].cells[1];
    if (td.firstChild) {
    td.firstChild.style.height = nhvis + "px";
    td.firstChild.firstChild.style.height = nh + "px";
    }
  end;
end;

procedure TCustomStringGrid.SetSelection(const Value: TGridRect);
var
  c,r,rc,rr: integer;
  sel: boolean;
  left,right,top,bottom: integer;

begin
  FSelection := Value;

  left := Value.Left;
  right := Value.Right;

  if Value.Left > Value.Right then
  begin
    left := Value.Right;
    right := Value.Left;
  end;

  top := Value.Top;
  bottom := Value.Bottom;

  if Value.Top > Value.Bottom then
  begin
    top := Value.Bottom;
    bottom := Value.Top;
  end;

  for r := FixedRows to RowCount - 1 do
  begin
    if goRowSelect in Options then
    begin
      rr := r - FixedRows;
      sel := (r >= top) and (r <= bottom);

      if sel then
      begin
        asm
          var tr = this.FNormalCells.rows[rr];
          tr.classList.add("selected");
        end;
      end
      else
      begin
        asm
          var tr = this.FNormalCells.rows[rr];
          tr.classList.remove("selected");
        end;
      end;
    end
    else
    for c := FixedCols to ColCount - 1 do
    begin

      rc := c - FixedCols;
      rr := r - FixedRows;

      sel := (c >= left) and (c <= right) and (r >= top) and (r <= bottom);

      if sel then
      begin
        asm
          var td = this.FNormalCells.rows[rr].cells[rc];
          td.classList.add("selected");
        end;
      end
      else
      begin
        asm
          var td = this.FNormalCells.rows[rr].cells[rc];
          td.classList.remove("selected");
        end;
      end;
    end;
  end;
end;

procedure TCustomStringGrid.SetTopRow(const Value: integer);
var
  pixVal: integer;
begin
  pixVal := (Value - FixedRows) * DefaultRowHeight;
  if Assigned(FNormalCells) and (pixVal >= 0) then
  begin
    FNormalCells.parentElement.parentElement.scrollTop := pixVal;
    if FixedCols > 0 then
      FFixedCol.parentElement.parentElement.scrollTop := pixVal;
  end;
end;

procedure TCustomStringGrid.ShowEdit;
begin
  StartEdit('');
end;

procedure TCustomStringGrid.StartEdit(ch: string);
var
  created: boolean;
  eh: TJSHTMLElement;
  s: string;
begin
  eh := ElementHandle;

  FEditRow := Row;
  FEditCol := Col;

  FEditMode := true;

  s := GetEditText(Col,Row);

  asm
    created = false;

    if (this.FEdit == undefined) {
      this.FEdit = document.createElement('INPUT');
      this.FEdit.style.setProperty('box-sizing','border-box');
      this.FEdit.style.setProperty('-webkit-box-sizing','border-box');
      this.FEdit.style.setProperty('-moz-box-sizing','border-box');
      created = true;
    }

    this.FOrigVal = s; //this.FSelectedCell.innerHTML;

    if (ch == '') {
      this.FEdit.value = s; //this.FSelectedCell.innerHTML;
      }
    else {
      this.FEdit.value = ch;
    }
    this.FEdit.style.width = "100%";
    this.FEdit.style.height = "100%";
    this.FEdit.style.fontFamily = eh.style.fontFamily;
    this.FEdit.style.fontSize = eh.style.fontSize;

    this.FEdit.setSelectionRange(0, this.FEdit.value.length)

    this.FSelectedCell.innerHTML = "";
    this.FSelectedCell.appendChild(this.FEdit);
    this.FEdit.focus();
  end;

  if created then
  begin
    FEdit.addEventListener('blur', FHandleEditBlurPtr);
    FEdit.addEventListener('keypress', FHandleEditKeypressPtr);


  end;


end;

function TCustomStringGrid.StopEdit: string;
var
  val: string;
begin
  Result := '';
  if FEditMode then
  begin
    FEditMode := false;

    val := (FEdit as TJSHTMLInputElement).value;

    ValidateCell(FEditCol, FEditRow, val);

    FSelectedCell.removeChild(FEdit);
    FSelectedCell.innerHTML := val;
    Result := val;

    UpdateCell(FEditCol, FEditRow, val);
  end;
end;

procedure TCustomStringGrid.TopLeftChanged;
begin
  if Assigned(OnTopLeftChanged) then
    OnTopLeftChanged(Self);
end;

procedure TCustomStringGrid.UpdateCell(ACol, ARow: integer; var AValue: string);
begin

end;

procedure TCustomStringGrid.UpdateElement;
var
  clr: string;
begin
  inherited;

  if IsUpdating then
    Exit;

  if Assigned(ElementHandle) then
  begin
    ElementHandle.style.setProperty('background-color', ColorToHTML(Color));
    ElementHandle.style.setProperty('overflow', 'hidden');

    if (BorderStyle = bsSingle) and not (BorderColor = clNone) and (ElementClassName = '') and not IsLinked then
    begin
      ElementHandle.style.setProperty('border', '1px solid '+ ColorToHTML(BorderColor));
      BorderWidth := 2;
    end
    else
    begin
      ElementHandle.style.setProperty('border', '');
      BorderWidth := 0;
    end;

    RenderGrid;

    clr := ColorToHTML(Color);

    // background color stringgrid (DIV & TBODY)
    asm
      this.FNormalCells.tBodies[0].style.setProperty('background-color', clr);
      this.FNormalCells.parentElement.parentElement.style.setProperty('background-color', clr);
    end;

    AddInstanceStyle(GetGridCSS);
    UpdateGridSize;
  end;
end;

procedure TCustomStringGrid.UpdateElementVisual;
var
  fixcol: string;
begin
  inherited;

  if IsUpdating then
    Exit;

  if Assigned(ElementHandle) and Assigned(FGrid) then
  begin
    fixcol := ColorToHTML(FFixedColor);

    if (FixedCols > 0) and (FixedRows > 0) then
    begin
      asm
        this.FFixedColRow.parentElement.style.setProperty('background-color',fixcol);
      end;
    end;

    if (FixedCols > 0) then
    begin
      asm
      this.FFixedCol.parentElement.style.setProperty('background-color',fixcol);
      end;
    end;

    if (FixedRows > 0) then
    begin
      asm
        this.FFixedRow.parentElement.style.setProperty('background-color',fixcol);
        this.FFixedRow.parentElement.parentElement.style.setProperty('background-color',fixcol);
      end;
    end;
  end;

end;

procedure TCustomStringGrid.UpdateGridSize;
var
  i,j,k,l,cw,rh: integer;

begin
  if not Assigned(ElementHandle) then
    Exit;

  if IsUpdating then
    Exit;

  if (RowCount = 0) or (ColCount = 0) then
    Exit;

  for i := 0 to FixedCols - 1 do
  begin
    cw := ColWidths[i];

    if (FixedRows > 0) and (FixedCols > 0) then
    begin
      asm
        for (j = 0; j < this.FFixedColRow.rows.length; j ++){
         var tr = this.FFixedColRow.rows[j];
         var td = tr.cells[i];
         td.style.width = cw + "px";
         td.style.maxWidth = cw + "px";
        }
      end;
    end;

    if (FixedCols > 0) then
    begin
      asm
        for (j = 0; j < this.FFixedCol.rows.length; j ++){
         var tr = this.FFixedCol.rows[j];
         var td = tr.cells[i];
         td.style.width = cw + "px";
         td.style.maxWidth = cw + "px";
        }
      end;
    end;
  end;

  for i := 0 to FixedRows - 1 do
  begin
    rh := RowHeights[i];

    if FixedCols > 0  then
    begin
      asm
        var tr = this.FFixedColRow.rows[i];
        tr.style.height = rh + "px";
      end;
    end;

    asm
      var tr = this.FFixedRow.rows[i];
      tr.style.height = rh + "px";
    end;
  end;

  for i := FixedCols to ColCount - 1 do
  begin
    cw := ColWidths[i];

    k := i - FixedCols;

    if (FixedRows > 0) then
    begin
      asm
        //if (this.FFixedRow.rows.length > 0) {
        for (i = 0; i < this.FFixedRow.rows.length; i++) {
          var tr = this.FFixedRow.rows[i];
          var td = tr.cells[k];
          td.style.width = cw + "px";
          td.style.maxWidth = cw + "px";
        }
      end;
    end;

    asm
      if (this.FNormalCells.rows.length > 0) {
        var tr = this.FNormalCells.rows[0];
        var td = tr.cells[k];
        td.style.width = cw + "px";
        td.style.maxWidth = cw + "px";
      }
    end;
  end;

  for i := FixedRows to RowCount - 1 do
  begin
    k := i - FixedRows;
    rh := RowHeights[i];

    for j := FixedCols to ColCount - 1 do
    begin
      l := j - FixedCols;
      cw := ColWidths[j];

      if FixedCols > 0 then
      begin
        asm
          var tr = this.FFixedCol.rows[k];
          tr.style.height = rh + "px";
        end;
      end;

      asm
        var tr = this.FNormalCells.rows[k];
        tr.style.height = rh + "px";

        td = tr.cells[l];
        td.style.maxWidth = cw + "px";
      end;
    end;
  end;
end;
procedure TCustomStringGrid.ValidateCell(ACol, ARow: integer;
  var AValue: string);
begin
  if Assigned(OnValidateEdit) then
    OnValidateEdit(Self, ACol, ARow, AValue);
end;

{$HINTS ON}


function TCustomStringGrid.HandleMouseMove(Event: TJSMouseEvent): Boolean;
var
  rindex, cindex: integer;
  l, t: Single;
  ss: TShiftState;
begin
  rindex := -1;
  cindex := -1;

  asm
    if (Event.target.tagName.toLowerCase() == 'td')
    {
      cindex = Event.target.cellIndex;
      var tr = Event.target.parentElement;
      rindex = tr.rowIndex;
    }
  end;


  if (cindex >= 0) and (rindex >= 0) and (FStartCell.X >= 0) and (FStartCell.Y >= 0) then
    Selection := GridRect(FStartCell.X, FStartCell.Y, cindex + FixedCols, rindex + FixedRows);

  Result := true;

  XYToClient(Event.clientX, Event.clientY, l, t);

  ss := GetMouseEventShiftState(Event);

  MouseMove(ss, Trunc(l), Trunc(t));
end;

function TCustomStringGrid.HandleMouseUp(Event: TJSMouseEvent): Boolean;
var
  l, t: Single;
  ss: TShiftState;
  mb: TMouseButton;
begin
  asm
    TMSStringGridresetResize();
  end;

  FStartCell.X := -1;
  FStartCell.Y := -1;
  Result := false;

  Event.stopPropagation;
  Event.cancelBubble := true;

  XYToClient(Event.clientX, Event.clientY, l, t);

  ss := GetMouseEventShiftState(Event);
  mb := GetMouseEventButton(Event);

  MouseUp(mb, ss, Trunc(l), Trunc(t));

end;

{ TCustomGrid }

procedure TCustomGrid.ColCountChanged(delta: integer);
begin
end;

procedure TCustomGrid.GridChanged;
begin
  //
end;

procedure TCustomGrid.RowCountChanged(delta: integer);
begin
end;

procedure TCustomGrid.SetColCount(const Value: integer);
var
  delta: integer;
begin
  if (FColCount <> Value) and (Value >= 0) then
  begin
    delta := Value - FColCount;
    FColCount := Value;
    if Assigned(ElementHandle) then
    begin
      ColCountChanged(delta);
      GridChanged;
    end;
  end;
end;

procedure TCustomGrid.SetRowCount(const Value: integer);
var
  delta: integer;
begin
  if (FRowCount <> Value) and (Value >= 0) then
  begin
    delta := Value - FRowCount;
    FRowCount := Value;
    if Assigned(ElementHandle) then
    begin
      RowCountChanged(delta);
      GridChanged;
    end;
  end;
end;

{ TCustomTableControl }

{$HINTS OFF}
procedure TCustomTableControl.AddCheckBox(ACol, ARow: integer;
  Checked: boolean);
var
  s: string;
  el: TJSHTMLElement;
begin
  s := '<INPUT TYPE="CHECKBOX"';
  if checked then
    s := s + ' CHECKED';
  s := s + '>';
  Cells[ACol,ARow] := s;

  el := CellElements[ACol, ARow];
  BindCellChildren(ACol, ARow, el);
end;

procedure TCustomTableControl.BindCellChildren(ACol, ARow: integer;
  AElement: TJSHTMLElement);
var
  el: TJSHTMLElement;
begin
  el := TJSHTMLElement(AElement.firstChild);

  if Assigned(el) and (el.tagName = 'INPUT') then
  begin
    if (lowercase(el.getAttribute('TYPE'))= 'checkbox') then
    begin
      el.addEventListener('click', @HandleCheckBoxClick);
    end;
  end;

end;

procedure TCustomTableControl.BindEvents;
begin
  inherited;
  RenderGridScript;
end;

procedure TCustomTableControl.Clear;
var
  i,j: integer;
begin
  for i := 0 to RowCount - 1 do
    for j := 0 to ColCount - 1 do
      begin
        Cells[j,i] := '';
      end;
end;

procedure TCustomTableControl.ColCountChanged(delta: integer);
var
  c: integer;
begin
  if IsUpdating or not Assigned(FTable) then
    Exit;

  if delta > 0 then
  begin
    asm
      var i = 0;
      var j = 0;
      var k = 0;
      var tr = undefined;

      var l = this.FTable.rows.length;

      for(j = 0; j < l; j++)
      {
        tr = this.FTable.rows[j];

        k = tr.cells.length;

         for(i = 0; i < delta; i++)
         {
           if ((j == 0) && (this.FRowHeader))
           {
             var th = document.createElement('th');
             th.setAttribute('scope','col');
             tr.appendChild(th);
           }
           else
             tr.insertCell(k);
         }
      }
    end;
  end;

  if delta < 0 then
  begin

    asm
      var i = 0;
      var j = 0;
      var k = 0;
      var tr = undefined;

      var l = this.FTable.rows.length;

      for(j = 0; j < l; j++)
      {
        tr = this.FTable.rows[j];

        k = tr.cells.length;

         for(i = 0; i < -delta; i++)
         {
           tr.deleteCell(k - i - 1);
         }
      }
    end;
  end;
end;
{$HINTS ON}

constructor TCustomTableControl.Create(AOwner: TComponent);
begin
  inherited;
  TabStop := false;
end;

function TCustomTableControl.CreateElement: TJSElement;
begin
  Result := document.createElement('DIV');
  FTable := nil;
end;

procedure TCustomTableControl.CreateInitialize;
begin
  inherited;
  FOptions := TTableControlOptions.Create(Self);
//  Color := clWindow;
 // TabStop := false;
  FColCount := 5;
  FRowCount := 10;
  FRowHeader := true;
  FColHeader := true;
  if (csDesigning in ComponentState) then
  begin
    Width := 400;
    Height := 300;
  end;
end;

destructor TCustomTableControl.Destroy;
begin
  FOptions.Free;
  inherited;
end;

procedure TCustomTableControl.DoCheckClick(ACol, ARow: Longint;
  Checked: boolean);
begin
  if Assigned(OnCheckClick) then
    OnCheckClick(Self, ACol, ARow, Checked);
end;

function TCustomTableControl.DoHttpAbort(Event: TEventListenerEvent): boolean;
begin
  if Assigned(OnHttpRequestError) then
    OnHttpRequestError(Self);

  Result := true;
end;

function TCustomTableControl.DoHttpLoadCsv(Event: TEventListenerEvent): boolean;
var
  sl: TStringList;
  arow: TStringList;
  i,j: integer;
  firstrow: integer;
  cd, cn: string;
  ce: TJSHTMLElement;
  req: TJSXMLHttpRequest;
begin
  req := TJSXMLHttpRequest(Event.target);

  if (req.status >= 200) and (req.status <= 208) then
  begin
    sl := TStringList.Create;

    sl.Text := req.responseText;

    if RowHeader and not FLoadFixed then
      firstrow := 1
    else
      firstrow := 0;

    RowCount := sl.Count + firstrow;

    arow := TStringList.Create;

    try
      for i := 0 to sl.Count - 1 do
        begin
          arow.StrictDelimiter := true;
          arow.Delimiter := FDelimiter;
          arow.DelimitedText := sl.Strings[i];

          if arow.Count > ColCount then
            ColCount := arow.Count;

          for j := 0 to arow.Count - 1 do
          begin
            cd := arow.Strings[j];
            GetCellData(j, i + firstrow, nil, cd);

            Cells[j, i + firstrow] := cd;

            ce := CellElements[j, i + firstrow];

            GetCellChildren(j, i + firstrow, nil, cd, ce);

            cn := '';
            GetCellClassName(j, i + firstrow, nil, cd, cn);
            if cn <> '' then
              ce.setAttribute('class',cn);
          end;
        end;
    finally
      arow.Free;
      sl.Free;
    end;

    if Assigned(OnHttpRequestSuccess) then
      OnHttpRequestSuccess(Self);
  end;

  Result := true;
end;

{$HINTS OFF}
function TCustomTableControl.DoHttpLoadJson(Event: TEventListenerEvent): boolean;
var
  J: TJSObject;
  JO: JSValue;
  JA: TJSArray;
  r,c,firstrow: integer;
  arow: string;
  sl: TStringList;
  cd,cn: string;
  ce: TJSHTMLElement;
  req: TJSXMLHttpRequest;

begin
  req := TJSXMLHttpRequest(Event.target);

  if (req.status >= 200) and (req.status <= 208) then
  begin
    J := TJSJSON.parseObject(req.responseText);

    if FDataNode <> '' then
      JA := TJSArray(J.Properties[FDataNode])
    else
      JA := TJSArray(J);


    if Assigned(JA) then
    begin
      sl := TStringList.Create;

      if RowHeader then
        firstrow := 1
      else
        firstrow := 0;

      RowCount := JA.length +  firstrow;

      for r := 0 to JA.length - 1 do
      begin
        JO := JA.Elements[r];

        c := 0;
        arow := '';

        asm
          var x = undefined;
          for (x in JO) {
            arow += "|" + JO[x];
            c++;
          }
        end;

        Delete(arow, 1, 1);
        sl.StrictDelimiter := true;
        sl.Delimiter := '|';
        sl.DelimitedText := arow;
        if ColCount < sl.Count  then
          ColCount := sl.Count;


        for c := 0 to sl.Count - 1 do
        begin
          cd := sl.Strings[c];
          GetCellData(c, r + firstrow, nil, cd);
          Cells[c, r + firstrow] := cd;

          ce := CellElements[c, r + firstrow];

          GetCellChildren(c, r + firstrow, nil, cd, ce);

          cn := '';
          GetCellClassName(c, r + firstrow, nil, cd, cn);
          if cn <> '' then
            ce.setAttribute('class',cn);
        end;
      end;

      sl.Free;
    end;

    if Assigned(OnHttpRequestSuccess) then
      OnHttpRequestSuccess(Self);
  end;

  Result := true;
end;
procedure TCustomTableControl.DoHttpRequest(ARequest: TJSXMLHttpRequest);
begin
  if Assigned(OnHttpRequest) then
    OnHttpRequest(Self, ARequest);
end;

procedure TCustomTableControl.EnableColResize;
var
  TableName: string;
  ResizeEnabled: Boolean;
begin
  TableName := Name;
  ResizeEnabled := Options.ResizeColumns;

  if not (csDesigning in ComponentState) then
  begin
    asm
      resizableGrid(TableName, ResizeEnabled);
    end;
  end;
end;

{$HINTS ON}

procedure TCustomTableControl.GetCellChildren(ACol, ARow: integer;
  AField: TField; AValue: string; AElement: TJSHTMLElement);
begin
  if Assigned(OnGetCellChildren) then
    OnGetCellChildren(Self, ACol, ARow, AField, AValue, AElement);
end;

procedure TCustomTableControl.GetCellClassName(ACol, ARow: integer;
  AField: TField; AValue: string; var AClassName: string);
begin
  if Assigned(OnGetCellClass) then
    OnGetCellClass(Self, ACol, ARow, AField, AValue, AClassName);
end;

procedure TCustomTableControl.GetCellData(ACol, ARow: integer; AField: TField;
  var AValue: string);
begin
  if Assigned(OnGetCellData) then
    OnGetCellData(Self, ACol, ARow, AField, AValue);
end;

function TCustomTableControl.GetCellElement(col, row: integer): TJSHTMLElement;
var
  res: TJSHTMLElement;
begin
  res := nil;

  if (col >= 0) and (row >= 0) and (col < ColCount) and (row < RowCount) then
  begin
    asm
      res = this.FTable.rows[row].cells[col];
    end;
  end;

  Result := res;
end;

function TCustomTableControl.GetCells(col, row: integer): string;
var
  res: string;

begin
  Result := '';

  if (col >= 0) and (row >= 0) and (col < ColCount) and (row < RowCount) then
  begin
    asm
      var td = this.FTable.rows[row].cells[col];
      res = td.innerHTML;
    end;

    Result := res;
  end;
end;

function TCustomTableControl.GetRowClassName(row: integer): string;
var
  res: string;
begin
  res := '';

  if (row >= 0) and (row < RowCount) then
  begin
    asm
      var tr = this.FTable.rows[row];
      res = tr.getAttribute('class');
    end;
  end;

  Result := res;
end;

function TCustomTableControl.HandleCheckBoxClick(Event: TJSEvent): Boolean;
var
  rindex, cindex: integer;
  chk: boolean;
begin
  Result := true;
  rindex := -1;
  cindex := -1;

  asm
    var el = Event.target;
    chk = el.checked;
    var d = el.parentElement;
    if (d.tagName.toLowerCase() == 'td')
    {
      cindex = d.cellIndex;
      var tr = d.parentElement;
      rindex = tr.rowIndex;
    }
  end;

  if (rindex <> -1) and (cindex <> -1) then
  begin
    DoCheckClick(cindex, rindex, chk);
  end;
end;

function TCustomTableControl.HandleDoClick(Event: TJSMouseEvent): Boolean;
var
  c,r: integer;
  el: TJSElement;
begin
  el := Event.target;

  if (el.tagName = 'TD') or (el.tagName = 'TH') then
  begin
     asm
       c = el.cellIndex;
       var tr = el.parentElement;
       r = tr.rowIndex;
     end;

     if Assigned(OnClickCell) then
       OnClickCell(Self, c, r);
  end;

  Result := true;
end;

function TCustomTableControl.HandleDoDblClick(Event: TJSMouseEvent): Boolean;
var
  c,r: integer;
  el: TJSElement;
begin
  el := Event.target;

  if (el.tagName = 'TD') or (el.tagName = 'TH') then
  begin
     asm
       c = el.cellIndex;
       var tr = el.parentElement;
       r = tr.rowIndex;
     end;

     if Assigned(OnDblClickCell) then
       OnDblClickCell(Self, c, r);
  end;
  Result := true;
end;

{$HINTS OFF}
function TCustomTableControl.HandleDoMouseMove(Event: TJSMouseEvent): Boolean;
var
  IsAutoWidth: Boolean;
begin
  inherited;

  IsAutoWidth := (WidthStyle in [ssAuto]);
  asm
    autoWidth = IsAutoWidth;
    resizeColumn(Event);
  end;

  Result := True;
end;
{$HINTS ON}

function TCustomTableControl.HandleDoMouseUp(Event: TJSMouseEvent): Boolean;
begin
  inherited;

  asm
    resetResize();
  end;

  Result := True;
end;

procedure TCustomTableControl.InitSample(AInitMethod: TInitMethod);
var
  i,j: integer;
begin
  for i := 0 to RowCount - 1 do
  begin
    for j := 0 to ColCount - 1 do
    begin
     case AInitMethod of
     imRandom:
       Cells[j,i] := IntToStr(Random(100));
     imLinear:
       Cells[j,i] := IntToStr(j)+':'+IntToStr(i);
     end;
    end;
  end;
end;

procedure TCustomTableControl.LoadFromCSV(const AURL: string; Delimiter: char = ';'; LoadFixed: boolean = false);
begin
  FDelimiter := Delimiter;
  FLoadFixed := LoadFixed;

  FReq := TJSXMLHttpRequest.new;
  FReq.addEventListener('load',@DoHttpLoadCsv);
  FReq.addEventListener('abort',@DoHttpAbort);
  DoHttpRequest(FReq);
  FReq.open('GET', AURL);
  FReq.send;
end;

procedure TCustomTableControl.LoadFromJSON(const AURL: string; ADataNode: string);
begin
  FDataNode := ADataNode;
  FReq := TJSXMLHttpRequest.new;
  FReq.addEventListener('load',@DoHttpLoadJson);
  FReq.addEventListener('abort',@DoHttpAbort);
  DoHttpRequest(FReq);
  FReq.open('GET', AURL);
  FReq.send;
end;

{$HINTS OFF}
procedure TCustomTableControl.RenderGrid;
var
  i: integer;
  table,tbody: TJSHTMLElement;
  frows, fcols: integer;
  rh,ch: boolean;
  headclass,tds,dtb: string;

begin
  if not Assigned(FTable) then
  begin
    FTable := document.createElement('TABLE');
    ElementHandle.appendChild(FTable);

    table := TJSHTMLElement(FTable);
    table.setAttribute('id', Name + 'Table');

    if RowHeader then
      frows := RowCount - 1
    else
      frows := RowCount;

    fcols := ColCount;
    rh := RowHeader;
    ch := ColHeader;

    if (csDesigning in ComponentState) then
      dtb := '1px dashed gray';

    if ElementTableClassName = '' then
    begin
      table.style.setProperty('border-collapse','collapse');
      table.setAttribute('border','0');
      table.setAttribute('cellpadding','0');
      table.setAttribute('cellspacing','0');
      table.setAttribute('width','100%');
      table.setAttribute('table-layout','fixed');
      table.setAttribute('height','100%');
      tds := '1px solid black';
    end
    else
    begin
      tds := '';
      table.setAttribute('class',ElementTableClassName);
    end;

    headclass := ElementHeaderClassName;

    asm
      while (table.firstChild) {
        table.removeChild(table.firstChild);
      }

      var i = 0;
      var j = 0;
      if (rh)
      {
        var theader = table.createTHead();

        if (headclass != "")
        {
          theader.setAttribute("class", headclass);
        }

        var tr = theader.insertRow(0);

        for(i=0; i < fcols; i++)
        {
          var th = document.createElement('th');
          th.setAttribute('scope','col');
          tr.appendChild(th);
        }
      }

      tbody = table.appendChild(document.createElement('tbody'));

      for(i=0; i < frows; i++)
      {
        var tr = tbody.insertRow(0);

        for(j=0; j < fcols; j++)
        {
          if ((j == 0) && (ch))
          {
            var th = document.createElement('th');
            th.setAttribute('scope','row');
            tr.appendChild(th);
          }
          else
          {
            tr.insertCell(j);
            var td = tr.cells[j];
            td.innerHTML = "&nbsp";

            if (tds != "") {
              //td.style.borderBottom = tds;
            }
            if (dtb != "")
            {
              td.style.borderRight = dtb;
              if (j == 1)
                td.innerHTML = frows - i;
            }
          }
        }
      }
    end;

    FBody := tbody;
  end;
  EnableColResize;
end;

procedure TCustomTableControl.RenderGridScript;
begin
  AddControlScriptSource(
  'var pageX,curCol,nxtCol,curColWidth,nxtColWidth,autoWidth,curTable,curTableWidth;'+
  'autoWidth = false;'+

  'function resizeColumn(e) {'+
  '   if (curCol) {'+
  '    var diffX = e.pageX - pageX;'+
  '		if ((nxtCol) && (!autoWidth)){'+
  '		 nxtCol.style.width = (nxtColWidth - diffX)+"px";'+
  '   } else {'+
//  '    curTable.style.width = (curTableWidth + diffX) + "px";'+
  '   }'+
  '   newColWidth = (curColWidth + diffX);'+
  '   if (newColWidth < 10)'+
  '    newColWidth = 10;'+
  '	  curCol.style.width = newColWidth + "px";'+
  '   }'+
  ' }'+

  'function resetResize() {'+
  '   curCol = undefined;'+
  '   nxtCol = undefined;'+
  '   pageX = undefined;'+
  '   nxtColWidth = undefined;'+
  '   curColWidth = undefined;'+
  '   curTable = undefined;'+
  '   curTableWidth = undefined;'+
  ' }'+

  'function resizableGrid(tablename, enabled) {'+
  ' var table = document.getElementById(tablename + "Table");'+
  ' if (!table) return;' +
  ' var row = table.getElementsByTagName("tr")[0],'+
  ' cols = row ? row.children : undefined;'+
  ' if (!cols) return;'+

  ' for (var i=0;i<cols.length;i++){'+
  '  var coldiv = document.getElementById(tablename + "Div" + i);'+

  '  if (coldiv)'+
  '    coldiv.remove();'+

  '  if (enabled) {'+
  '    var div = createDiv();'+
  '    cols[i].appendChild(div);'+
  '    cols[i].style.position = "relative";'+
  '    div.id = tablename + "Div" + i;'+
  '    setListeners(div);'+
  '  }'+
  ' }'+

  ' function setListeners(div){'+

  '  div.addEventListener("mousedown", function (e) {'+
  '   curCol = e.target.parentElement;'+
  '   nxtCol = curCol.nextElementSibling;'+
  '   pageX = e.pageX;'+

  '   curColWidth = curCol.offsetWidth;'+
  '   curTable = curCol.parentElement.parentElement.parentElement;'+
  '   curTableWidth = curTable.offsetWidth;'+
  '   if (nxtCol)'+
  '    nxtColWidth = nxtCol.offsetWidth;'+
  '  });'+

  '  div.addEventListener("mouseover", function (e) {'+
  '   e.target.style.borderRight = "2px solid #0000ff";'+
  '  });'+

  '  div.addEventListener("mouseout", function (e) {'+
  '   e.target.style.borderRight = "";'+
  '  });'+

  '  document.addEventListener("mousemove", function (e) {'+
  '   resizeColumn(e);'+
  '  });'+

  '  document.addEventListener("mouseup", function (e) {'+
  '   resetResize(e);'+
  '  });'+
  ' }'+

  ' function createDiv(){'+
  '  var div = document.createElement("div");'+
  '  div.style.top = 0;'+
  '  div.style.right = 0;'+
  '  div.style.width = "10px";'+
  '  div.style.position = "absolute";'+
  '  div.style.cursor = "col-resize";'+
  '  div.style.userSelect = "none";'+
  '  div.style.height = "100%";'+
  '  div.innerHTML = "&nbsp;";'+
//  '  div.style.border = "1px solid red";'+
  '  return div;'+
  ' }'+

  '};');
end;

procedure TCustomTableControl.RowCountChanged(delta: integer);
var
  r: integer;
  tbody: TJSElement;
begin
  if IsUpdating or not Assigned(FTable) then
    Exit;

  tbody := FBody;

  if (delta > 0) then
  begin

    asm
      var i = 0;
      var j = 0;
      var tr = undefined;
      var l = tbody.rows.length;

      for(i = 0;i < delta; i++)
      {
         tr = tbody.insertRow(l);
         for(j = 0; j < this.FColCount; j++)
         {

          if ((j == 0) && (this.FColHeader))
          {
            var th = document.createElement('th');
            th.setAttribute('scope','row');
            tr.appendChild(th);
          }
          else
            tr.insertCell(j);
         }
      }
    end;
  end;

  if delta < 0 then
  begin
    asm
      var i = 0;
      var l = this.FBody.rows.length;
      for(i = 0;i < -delta; i++) {
        this.FBody.deleteRow(l - i - 1);
      }
    end;
  end;
end;
{$HINTS ON}


procedure TCustomTableControl.SetCells(col, row: integer; const Value: string);
begin
  if (col >= 0) and (row >= 0) and (col < ColCount) and (row < RowCount) then
  begin
    asm
      var td = this.FTable.rows[row].cells[col];
      td.innerHTML = Value;
    end;

    if (row = 0) then
      EnableColResize;
  end;
end;

procedure TCustomTableControl.SetElementHeaderClassName(
  const Value: TElementClassName);
var
  head: TJSHTMLElement;
begin
  if (FElementHeaderClassName <> Value) then
  begin
    FElementHeaderClassName := Value;
    if Assigned(FTable) then
    begin
      head := TJSHTMLElement(FTable.firstChild);
      if Assigned(head) and (head.tagName = 'THEAD') then
        head.setAttribute('class',ElementHeaderClassName);
    end;
  end;
end;

procedure TCustomTableControl.SetElementTableClassName(
  const Value: TElementClassName);
begin
  if (FElementTableClassName <> Value) then
  begin
    FElementTableClassName := Value;
    if Assigned(FTable) then
      FTable.setAttribute('class',ElementTableClassName);
  end;
end;

procedure TCustomTableControl.SetOptions(const Value: TTableControlOptions);
begin
  FOptions.Assign(Value);
end;

procedure TCustomTableControl.SetRowClassName(row: integer; const Value: string);
begin
  if (row >= 0) and (row < RowCount) then
  begin
    asm
      var tr = this.FTable.rows[row];
      tr.setAttribute('class',Value);
    end;
  end;
end;

procedure TCustomTableControl.SetRowCount(const Value: integer);
var
  delta: integer;
begin
  if (FRowCount <> Value) and (Value >= 0) then
  begin
    delta := Value - FRowCount;

    if (FRowcount = 0) and RowHeader then
      delta := Value - 1;

    FRowCount := Value;
    RowCountChanged(delta);
    GridChanged;
  end;

end;

procedure TCustomTableControl.UpdateElement;
begin
  inherited;

  if IsUpdating then
    Exit;

  if Assigned(ElementHandle) then
  begin
    if Options.ScrollVertical then
      ElementHandle.style.setProperty('overflow-y','scroll')
    else
      ElementHandle.style.setProperty('height','');

    if (csDesigning in ComponentState) then
    begin
      ElementHandle.style.setProperty('width', IntToStr(Width) + 'px');
      ElementHandle.style.setProperty('height', IntToStr(Height) + 'px');
    end;

    // allow selection in labels
    ElementHandle.style.setProperty('user-select', '');

    // allow default caret on text
    if Cursor = crDefault then
      ElementHandle.style.setProperty('cursor', '');

    if (BorderStyle = bsSingle) and (BorderColor <> clNone) and (ElementClassName = '') and (ElementTableClassName = '') and not IsLinked then
      ElementHandle.style.setProperty('border', '1px ' + ColorToHTML(BorderColor)+' solid')
    else
      ElementHandle.style.setProperty('border', '');

    if (Color <> clNone) and (Color <> clWindow) then
      ElementHandle.style.setProperty('background-color', ColorToHTML(Color))
    else
      ElementHandle.style.setProperty('background-color', '');

    RenderGrid;
  end;
end;


{ TResponsiveGridItem }

procedure TResponsiveGridItem.SetHTML(const Value: string);
begin
  FHTML := Value;
  Changed(false);
end;

{ TResponsiveGridItems }

function TResponsiveGridItems.Add: TResponsiveGridItem;
begin
  Result := TResponsiveGridItem(inherited Add);
  DoItemAdd(Result.Index);
end;

procedure TResponsiveGridItems.Clear;
begin
  inherited Clear;

  DoItemClear;
end;

constructor TResponsiveGridItems.Create(AOwner: TComponent);
begin
  inherited Create(AOwner, TResponsiveGridItem);
end;

procedure TResponsiveGridItems.Delete(Index: integer);
begin
  inherited Delete(Index);
  DoItemDelete(Index);
end;

procedure TResponsiveGridItems.DoItemAdd(Index: integer);
begin
  if Assigned(OnItemAdd) then
    OnItemAdd(Self, Index);
end;

procedure TResponsiveGridItems.DoItemClear;
begin
  if Assigned(OnItemClear) then
    OnItemClear(Self);
end;

procedure TResponsiveGridItems.DoItemDelete(Index: integer);
begin
  if Assigned(OnItemDelete) then
    OnItemDelete(Self, Index);
end;

procedure TResponsiveGridItems.DoItemInsert(Index: integer);
begin
  if Assigned(OnItemInsert) then
    OnItemInsert(Self, Index);
end;

procedure TResponsiveGridItems.DoItemUpdate(Index: integer);
begin
  if Assigned(OnItemUpdate) then
    OnItemUpdate(Self, Index);
end;

function TResponsiveGridItems.GetItem(Index: integer): TResponsiveGridItem;
begin
  Result := TResponsiveGridItem(inherited Items[Index]);
end;

function TResponsiveGridItems.Insert(Index: integer): TResponsiveGridItem;
begin
  Result := TResponsiveGridItem(inherited Insert(Index));
  DoItemInsert(Result.Index);
end;

procedure TResponsiveGridItems.SetItem(Index: integer;
  const Value: TResponsiveGridItem);
begin
  inherited Items[Index] := Value;
end;

procedure TResponsiveGridItems.Update(Item: TCollectionItem);
begin
  inherited;
  if Assigned(Item) then
    DoItemUpdate(Item.Index);
end;

{ TResponsiveGrid }

procedure TResponsiveGrid.BindElement;
begin
  inherited;
end;

constructor TResponsiveGrid.Create(AOwner: TComponent);
begin
  inherited;
end;

function TResponsiveGrid.CreateElement: TJSElement;
begin
  Result := document.createElement('DIV');
end;

procedure TResponsiveGrid.CreateInitialize;
begin
  inherited;
  FListElement := nil;

  FOptions := TResponsiveGridOptions.Create;
  FOptions.OnChange := OptionsChanged;
  FItems := TResponsiveGridItems.Create(Self);
  FItems.PropName := 'Items';

  FItems.OnItemAdd := HandleItemAdd;
  FItems.OnItemUpdate := HandleItemUpdate;
  FItems.OnItemDelete := HandleItemDelete;
  FItems.OnItemInsert := HandleItemInsert;
  FItems.OnItemClear := HandleItemClear;

  if (csDesigning in ComponentState) then
  begin
    Width := 400;
    Height := 300;
  end;
end;

procedure TResponsiveGrid.CreateControl;
begin
  inherited;
end;

destructor TResponsiveGrid.Destroy;
begin
  FOptions.Free;
  FItems.Free;
  inherited;
end;

function TResponsiveGrid.DoHttpAbort(Event: TEventListenerEvent): boolean;
begin
  if Assigned(OnHttpRequestError) then
    OnHttpRequestError(Self);
  Result := true;
end;

function TResponsiveGrid.DoHttpLoadCsv(Event: TEventListenerEvent): boolean;
var
  sl,arow,columns: TStringList;
  i,c: integer;
  itm: TResponsiveGridItem;
  ident,html, htmlvalue: string;
  req: TJSXMLHttpRequest;

begin
  req := TJSXMLHttpRequest(Event.target);

  if (req.status >= 200) and (req.status <= 208) then
  begin
    sl := TStringList.Create;
    sl.Text := req.responseText;

    arow := TStringList.Create;
    arow.StrictDelimiter := true;
    arow.Delimiter := FDelimiter;

    if sl.Count > 0 then
    begin
      columns := TStringList.Create;
      columns.StrictDelimiter := true;
      columns.Delimiter := FDelimiter;
      columns.DelimitedText := sl.Strings[0];

      for i := 0 to sl.Count - 1 do
      begin
        arow.DelimitedText := sl.Strings[i];

        if Options.ItemTemplate = '' then
        begin
          Items.Add.HTML := arow.CommaText;
        end
        else
        begin
          itm := Items.Add;

          html := Options.ItemTemplate;
          for c := 0 to arow.Count - 1 do
          begin
            ident := '(%' + columns.Strings[c] + '%)';
            if Pos(ident, html) > 0 then
            begin
              htmlvalue := '';
              if c < arow.Count then
                htmlvalue := arow.Strings[c];

              DoItemGetFieldValue(itm.Index, columns.Strings[c], htmlvalue);
              html := StringReplace(html, ident, htmlvalue, [rfReplaceAll]);
            end;
          end;

          itm.HTML := html;

          DoItemCreated(itm.Index);
        end;
      end;

      columns.Free;

    end;

    arow.Free;
    sl.Free;

  end;

  Result := true;
end;

{$HINTS OFF}
function TResponsiveGrid.DoHttpLoadJson(Event: TEventListenerEvent): boolean;
var
  J: TJSObject;
  JO: JSValue;
  JA: TJSArray;
  r,c: integer;
  arow,ident,html, htmlvalue: string;
  sl: TStringList;
  itm: TResponsiveGridItem;
  req: TJSXMLHttpRequest;

begin
  req := TJSXMLHttpRequest(Event.target);

  if (req.status >= 200) and (req.status <= 208) then
  begin
    Items.Clear;

    J := TJSJSON.parseObject(req.responseText);

    if FDataNode <> '' then
      JA := TJSArray(J.Properties[FDataNode])
    else
      JA := TJSArray(J);


    if Assigned(JA) then
    begin
      sl := TStringList.Create;

      //RowCount := JA.length +  FixedRows;

      for r := 0 to JA.length - 1 do
      begin
        // array element
        JO := JA.Elements[r];

        c := 0;
        arow := '';

        asm
          var x = undefined;
          for (x in JO) {
            arow += "|" + x + "=" + JO[x];
            c++;
          }
        end;

        Delete(arow, 1, 1);
        sl.StrictDelimiter := true;
        sl.Delimiter := '|';
        sl.DelimitedText := arow;

        if Options.ItemTemplate = '' then
        begin
          Items.Add.HTML := sl.CommaText;
        end
        else
        begin
          itm := Items.Add;

          html := Options.ItemTemplate;
          for c := 0 to sl.Count - 1 do
          begin
            ident := '(%' + sl.Names[c] + '%)';
            if Pos(ident, html) > 0 then
            begin
              htmlvalue := sl.Values[sl.Names[c]];
              DoItemGetFieldValue(itm.Index, sl.Names[c], htmlvalue);
              html := StringReplace(html, ident, htmlvalue, [rfReplaceAll]);
            end;
          end;

          itm.HTML := html;

          DoItemCreated(itm.Index);
        end;
      end;

      sl.Free;
    end;

    if Assigned(OnHttpRequestSuccess) then
      OnHttpRequestSuccess(Self);
  end;

  Result := true;
end;

procedure TResponsiveGrid.DoHttpRequest(ARequest: TJSXMLHttpRequest);
begin
  if Assigned(OnHttpRequest) then
    OnHttpRequest(Self, ARequest);
end;

{$HINTS ON}

procedure TResponsiveGrid.DoItemCreated(Index: integer);
begin
  if Assigned(OnItemCreated) then
    OnItemCreated(Self, Index);
end;

procedure TResponsiveGrid.DoItemGetFieldValue(Index: integer;
  AFieldName: string; var AValue: string);
begin
  if Assigned(OnItemGetFieldValue) then
    OnItemGetFieldValue(Self, Index, AFieldName, AValue);
end;

procedure TResponsiveGrid.FontChanged;
begin
  inherited;
  UpdateElement;
end;

function TResponsiveGrid.TargetIsParent(tgt,el: TJSElement): boolean;
var
  pe: TJSElement;
begin
  Result := false;
  pe := tgt;
  repeat
    if el = pe then
    begin
      Result := true;
      break;
    end;
    pe := pe.parentElement;

  until not Assigned(pe);
end;

function TResponsiveGrid.HandleDoClick(Event: TJSMouseEvent): Boolean;
var
  i: integer;
  el: TJSHTMLElement;

begin
  Result := inherited HandleDoClick(Event);

  for i := 0 to Items.Count - 1 do
  begin
    el := TJSHTMLElement(ListElementHandle.children.Items[i]);
    if Assigned(el) then
    begin
      // search HTML DIV element in list that is clicked
      if TargetIsParent(Event.target, el) then
      begin
        FItemIndex := i;
        el.classList.add(Name+'_Selected');
        HandleDoItemClick(i);
      end
      else
        el.classList.remove(Name+'_Selected');
    end;
  end;
end;

function TResponsiveGrid.HandleDoDblClick(Event: TJSMouseEvent): Boolean;
var
  i: integer;
  el: TJSHTMLElement;
begin
  Result := inherited HandleDoClick(Event);

  for i := 0 to Items.Count - 1 do
  begin
    el := TJSHTMLElement(ListElementHandle.children.Items[i]);

    if TargetIsParent(Event.target, el) then
    begin
      HandleDoItemDblClick(i);
    end;
  end;
end;

procedure TResponsiveGrid.HandleDoItemClick(Index: integer);
begin
  if Assigned(OnItemClick) then
    OnItemClick(Self, Index);
end;

procedure TResponsiveGrid.HandleDoItemDblClick(Index: integer);
begin
  if Assigned(OnItemDblClick) then
    OnItemDblClick(Self, Index);
end;

function TResponsiveGrid.HandleDoMouseEnter(Event: TJSMouseEvent): Boolean;
begin
  Result := inherited HandleDoMouseEnter(Event);
end;

procedure TResponsiveGrid.HandleItemAdd(Sender: TObject; Index: integer);
var
  el: TJSHTMLElement;
begin
  el := TJSHTMLElement(document.createElement('DIV'));
  Items.Items[Index].FElementHandle := el;

  ListElementHandle.appendChild(el);
  el.innerHTML := Items.Items[Index].HTML;
  if Options.ItemClassName <> '' then
    el.setAttribute('class',Options.ItemClassName);
end;

procedure TResponsiveGrid.HandleItemClear(Sender: TObject);
var
  i: integer;
begin
  for i := ListElementHandle.childElementCount - 1 downto 0 do
  begin
    ListElementHandle.removeChild(ListElementHandle.children.items[0]);
  end;
end;

procedure TResponsiveGrid.HandleItemDelete(Sender: TObject; Index: integer);
begin
  if Assigned(ListElementHandle) then
  begin
    ListElementHandle.removeChild(ListElementHandle.children.Items[Index]);
  end;
end;

procedure TResponsiveGrid.HandleItemInsert(Sender: TObject; Index: integer);
var
  el: TJSHTMLElement;
begin
  el := TJSHTMLElement(document.createElement('DIV'));
  Items.Items[Index].FElementHandle := el;

  if Items.Count <= 1 then
    ListElementHandle.appendChild(el)
  else
    ListElementHandle.insertBefore(el, ListElementHandle.children.Items[Index]);

  el.innerHTML := Items.Items[Index].HTML;
  if Options.ItemClassName <> '' then
    el.setAttribute('class',Options.ItemClassName);
end;

procedure TResponsiveGrid.HandleItemUpdate(Sender: TObject; Index: integer);
var
  el: TJSHTMLElement;
begin
  if Assigned(ListElementHandle) then
  begin
    el := TJSHTMLElement(ListElementHandle.children.Items[Index]);
    if not Assigned(el) then
    begin
      HandleItemInsert(Self, Index);
    end
    else
      el.innerHTML := Items.Items[Index].HTML;
  end;
end;

function TResponsiveGrid.ListElementHandle: TJSElement;
begin
  if not Assigned(FListElement) then
  begin
    FListElement := TJSHTMLElement(document.createElement('DIV'));
    FListElement['width'] := '100%';
    ElementHandle.appendChild(FListElement);
    Result := FListElement;
  end
  else
    Result := FListElement;
end;

procedure TResponsiveGrid.Loaded;
begin
  inherited;
  RenderGrid;
end;

procedure TResponsiveGrid.LoadFromCSV(const AURL: string; Delimiter: char = ';');
begin
  FDelimiter := Delimiter;

  FReq := TJSXMLHttpRequest.new;
  FReq.addEventListener('load',@DoHttpLoadCsv);
  FReq.addEventListener('abort',@DoHttpAbort);
  DoHttpRequest(FReq);
  FReq.open('GET', AURL);
  FReq.send;
end;

procedure TResponsiveGrid.LoadFromJSON(const AURL: string; ADataNode: string);
begin
  FDataNode := ADataNode;
  FReq := TJSXMLHttpRequest.new;
  FReq.addEventListener('load',@DoHttpLoadJson);
  FReq.addEventListener('abort',@DoHttpAbort);
  DoHttpRequest(FReq);
  FReq.open('GET', AURL);
  FReq.send;
end;

procedure TResponsiveGrid.OptionsChanged(Sender: TObject);
begin
  UpdateElement;
end;

procedure TResponsiveGrid.RenderGrid;
var
  i, c, w: integer;
  el: TJSHTMLElement;
begin

  if (csDesigning in ComponentState) then
  begin
    w := (Options.ItemWidthMin + Options.ItemGap);
    if w <= 0 then
      w := 1;
    c := Round(Width / w);
    if c < 1 then
      c := 1;
    for i := 0 to c - 1 do
    begin
      el := TJSHTMLElement(document.createElement('DIV'));
      ListElementHandle.appendChild(el);
      el.innerHTML := '';
      if Options.ItemClassName <> '' then
        el.setAttribute('class',Options.ItemClassName);
    end;
  end;

  Exit;

  for i := 0 to Items.Count - 1 do
  begin
    el := TJSHTMLElement(document.createElement('DIV'));
    ListElementHandle.appendChild(el);
    el.innerHTML := Items.Items[i].HTML;
    if Options.ItemClassName <> '' then
      el.setAttribute('class',Options.ItemClassName);
  end;
end;

procedure TResponsiveGrid.SetItemIndex(const Value: integer);
var
  el: TJSHTMLElement;
  i: integer;

begin
  FItemIndex := Value;

  if (csLoading in ComponentState) then
    Exit;

  for i := 0 to Items.Count - 1 do
  begin
    el := TJSHTMLElement(ListElementHandle.children.Items[i]);
    if (i = FItemIndex) then
    begin
      el.setAttribute('class',Options.ItemClassName + ' ' + Name+'_Selected');
    end
    else
      el.setAttribute('class',Options.ItemClassName);
  end;
end;

procedure TResponsiveGrid.SetItems(const Value: TResponsiveGridItems);
begin
  FItems.Assign(Value);
end;

procedure TResponsiveGrid.SetOptions(const Value: TResponsiveGridOptions);
begin
  FOptions.Assign(Value);
end;

procedure TResponsiveGrid.UpdateElement;
var
  s, fs: string;
  ITMWIDTHMIN: string;
  ITMGAP: string;
  ITMHEIGHT: string;
  itemstyle, itemstylehover, itemstyleselected: string;

begin
  inherited;

  if IsUpdating then
    Exit;

  if (csLoading in ComponentState) then
    Exit;

  if Assigned(ElementHandle) then
  begin
    ITMWIDTHMIN := IntToStr(Options.ItemWidthMin);
    ITMHEIGHT := IntToStr(Options.ItemHeight);
    ITMGAP := IntToStr(Options.ItemGap);

    ListElementHandle.setAttribute('class', Self.Name);

    fs := '';

    if (ElementClassName = '') and (ElementFont = efProperty) then
      fs := CSSFont(Self.Font);

    itemstyle := '';
    itemstylehover := '';
    itemstyleselected := '';

    if Options.ItemColor <> clNone then
      itemstyle := 'background-color:'+ColorToHTML(Options.ItemColor)+';';

    if (csDesigning in ComponentState) then
        itemstyle := itemstyle + 'border: 1px dotted silver;'
    else if Options.ItemBorderColor <> clNone then
      itemstyle := itemstyle + 'border: 1px solid ' + ColorToHTML(Options.ItemBorderColor)+';';

    if Options.ItemPadding <> 0 then
      itemstyle := itemstyle +  'padding:' + IntToStr(Options.ItemPadding)+';';

    if Options.ItemHoverColor <> clNone then
      itemstylehover := 'background-color:' + ColorToHTML(Options.ItemHoverColor)+';';

    if Options.ItemHoverBorderColor <> clNone then
      itemstylehover := itemstylehover + 'border: 1px solid '+ColorToHTML(Options.ItemHoverBorderColor);

    if Options.ItemSelectedColor <> clNone then
      itemstyleselected := 'background-color:' + ColorToHTML(Options.ItemSelectedColor)+';';

    if Options.ItemSelectedBorderColor <> clNone then
      itemstyleselected := itemstyleselected + 'border: 1px solid '+ColorToHTML(Options.ItemSelectedBorderColor)+';';

    if Options.ItemSelectedTextColor <> clNone then
      itemstyleselected := itemstyleselected + 'color:'+ColorToHTML(Options.ItemSelectedTextColor)+';';

    if Options.ScrollVertical then
      ElementHandle.style.setProperty('overflow-y','auto')
    else
      ElementHandle.style.setProperty('overflow-y','hidden');

    s := '.'+Name+' {'+
       'display: grid; grid-template-columns: repeat(auto-fill, minmax('+ ITMWIDTHMIN +'px, 1fr));'+
       ' grid-gap: '+ ITMGAP + 'px;'+
       '}' + #13
       + '.'+Name+' > div { ' + itemstyle +'height: '+ ITMHEIGHT + 'px; ' + fs +' }'+#13
       + '.'+Name+' > div:hover {' + itemstylehover + ' '+ fs + ' }'+#13
       + '.'+Name+'_Selected {' + itemstyleselected + 'height: '+ ITMHEIGHT + 'px;' + fs + '}'+#13;

    AddInstanceStyle(s);
  end;
end;

{ TResponsiveGridOptions }

procedure TResponsiveGridOptions.Assign(Source: TPersistent);
begin
  if (Source is TResponsiveGridOptions) then
  begin
    FItemWidthMin := (Source as TResponsiveGridOptions).ItemWidthMin;
    FItemHeight := (Source as TResponsiveGridOptions).ItemHeight;
  end;
end;

procedure TResponsiveGridOptions.Changed;
begin
  if Assigned(OnChange) then
    OnChange(Self);
end;

constructor TResponsiveGridOptions.Create;
begin
  inherited;
  FItemWidthMin := 100;
  FItemHeight := 100;
  FItemGap := 10;
  FScrollVertical := true;
  FItemColor := clNone;
  FItemBorderColor := clNone;
  FItemHoverColor := clNone;
  FItemHoverBorderColor := clNone;
  FItemSelectedColor := clNone;
  FItemSelectedBorderColor := clNone;
  FItemSelectedTextColor := clNone;
end;

procedure TResponsiveGridOptions.SetItemBorderColor(const Value: TColor);
begin
  if (FItemBorderColor <> Value) then
  begin
    FItemBorderColor := Value;
    Changed;
  end;
end;

procedure TResponsiveGridOptions.SetItemColor(const Value: TColor);
begin
  if (FItemColor <> Value) then
  begin
    FItemColor := Value;
    Changed;
  end;
end;

procedure TResponsiveGridOptions.SetItemGap(const Value: integer);
begin
  if (FItemGap <> Value) then
  begin
    FItemGap := Value;
    Changed;
  end;
end;

procedure TResponsiveGridOptions.SetItemHeight(const Value: integer);
begin
  if (FItemHeight <> Value) then
  begin
    FItemHeight := Value;
    Changed;
  end;
end;

procedure TResponsiveGridOptions.SetItemHoverBorderColor(const Value: TColor);
begin
  if (FItemHoverBorderColor <> Value) then
  begin
    FItemHoverBorderColor := Value;
    Changed;
  end;
end;

procedure TResponsiveGridOptions.SetItemHoverColor(const Value: TColor);
begin
  if (FItemHoverColor <> Value) then
  begin
    FItemHoverColor := Value;
    Changed;
  end;
end;

procedure TResponsiveGridOptions.SetItemPadding(const Value: integer);
begin
  if (FItemPadding <> Value) then
  begin
    FItemPadding := Value;
    Changed;
  end;
end;

procedure TResponsiveGridOptions.SetItemSelectedBorderColor(
  const Value: TColor);
begin
  if FItemSelectedBorderColor <> Value then
  begin
    FItemSelectedBorderColor := Value;
    Changed;
  end;
end;

procedure TResponsiveGridOptions.SetItemSelectedColor(const Value: TColor);
begin
  if (FItemSelectedColor <> Value) then
  begin
    FItemSelectedColor := Value;
    Changed;
  end;
end;

procedure TResponsiveGridOptions.SetItemSelectedTextColor(const Value: TColor);
begin
  if (FItemSelectedTextColor <> Value) then
  begin
    FItemSelectedTextColor := Value;
    Changed;
  end;
end;

procedure TResponsiveGridOptions.SetItemTemplate(const Value: string);
begin
  if (FItemTemplate <> Value) then
  begin
    FItemTemplate := Value;
    Changed;
  end;
end;

procedure TResponsiveGridOptions.SetItemWidthMin(const Value: integer);
begin
  if (FItemWidthMin <> Value) then
  begin
    FItemWidthMin := Value;
    Changed;
  end;
end;

procedure TResponsiveGridOptions.SetScrollVertical(const Value: boolean);
begin
  if (FScrollVertical <> Value) then
  begin
    FScrollVertical := Value;
    Changed;
  end;
end;

{$HINTS ON}

{ TTableControlOptions }

procedure TTableControlOptions.Assign(Source: TPersistent);
begin
  if (Source is TTableControlOptions) then
  begin
    FScrollVertical := (Source as TTableControlOptions).ScrollVertical;
    FResizeColumns := (Source as TTableControlOptions).ResizeColumns;
  end;

end;

constructor TTableControlOptions.Create(AOwner: TCustomTableControl);
begin
  inherited;
  FOwner := AOwner;
end;

procedure TTableControlOptions.SetResizeColumns(const Value: boolean);
begin
  FResizeColumns := Value;
  FOwner.EnableColResize;
end;

end.
